(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory(require("axios"));else if (typeof define === 'function' && define.amd) define(["axios"], factory);else if (typeof exports === 'object') exports["axiosCacheAdapter"] = factory(require("axios"));else root["axiosCacheAdapter"] = factory(root[undefined]);
})(window, function (__WEBPACK_EXTERNAL_MODULE_axios__) {
  return /******/function (modules) {
    // webpackBootstrap
    /******/ // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/ // The require function
    /******/
    function __webpack_require__(moduleId) {
      /******/
      /******/ // Check if module is in cache
      /******/if (installedModules[moduleId]) {
        /******/return installedModules[moduleId].exports;
        /******/
      }
      /******/ // Create a new module (and put it into the cache)
      /******/
      var module = installedModules[moduleId] = {
        /******/i: moduleId,
        /******/l: false,
        /******/exports: {}
        /******/
      };
      /******/
      /******/ // Execute the module function
      /******/
      modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
      /******/
      /******/ // Flag the module as loaded
      /******/
      module.l = true;
      /******/
      /******/ // Return the exports of the module
      /******/
      return module.exports;
      /******/
    }
    /******/
    /******/
    /******/ // expose the modules object (__webpack_modules__)
    /******/
    __webpack_require__.m = modules;
    /******/
    /******/ // expose the module cache
    /******/
    __webpack_require__.c = installedModules;
    /******/
    /******/ // define getter function for harmony exports
    /******/
    __webpack_require__.d = function (exports, name, getter) {
      /******/if (!__webpack_require__.o(exports, name)) {
        /******/Object.defineProperty(exports, name, {
          enumerable: true,
          get: getter
        });
        /******/
      }
      /******/
    };
    /******/
    /******/ // define __esModule on exports
    /******/
    __webpack_require__.r = function (exports) {
      /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
        /******/Object.defineProperty(exports, Symbol.toStringTag, {
          value: 'Module'
        });
        /******/
      }
      /******/
      Object.defineProperty(exports, '__esModule', {
        value: true
      });
      /******/
    };
    /******/
    /******/ // create a fake namespace object
    /******/ // mode & 1: value is a module id, require it
    /******/ // mode & 2: merge all properties of value into the ns
    /******/ // mode & 4: return value when already ns object
    /******/ // mode & 8|1: behave like require
    /******/
    __webpack_require__.t = function (value, mode) {
      /******/if (mode & 1) value = __webpack_require__(value);
      /******/
      if (mode & 8) return value;
      /******/
      if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
      /******/
      var ns = Object.create(null);
      /******/
      __webpack_require__.r(ns);
      /******/
      Object.defineProperty(ns, 'default', {
        enumerable: true,
        value: value
      });
      /******/
      if (mode & 2 && typeof value != 'string') for (var key in value) __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
      /******/
      return ns;
      /******/
    };
    /******/
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/
    __webpack_require__.n = function (module) {
      /******/var getter = module && module.__esModule ? /******/function getDefault() {
        return module['default'];
      } : /******/function getModuleExports() {
        return module;
      };
      /******/
      __webpack_require__.d(getter, 'a', getter);
      /******/
      return getter;
      /******/
    };
    /******/
    /******/ // Object.prototype.hasOwnProperty.call
    /******/
    __webpack_require__.o = function (object, property) {
      return Object.prototype.hasOwnProperty.call(object, property);
    };
    /******/
    /******/ // __webpack_public_path__
    /******/
    __webpack_require__.p = "";
    /******/
    /******/
    /******/ // Load entry module and return exports
    /******/
    return __webpack_require__(__webpack_require__.s = "./src/index.js");
    /******/
  }
  /************************************************************************/
  /******/({
    /***/"./node_modules/cache-control-esm/index.js": (
    /*!*************************************************!*\
      !*** ./node_modules/cache-control-esm/index.js ***!
      \*************************************************/
    /*! exports provided: CacheControl, parse, format, default */
    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "CacheControl", function () {
        return CacheControl;
      });
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "parse", function () {
        return parse;
      });
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "format", function () {
        return format;
      });
      /* harmony import */
      var core_js_modules_es6_array_from__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es6.array.from */"./node_modules/core-js/modules/es6.array.from.js");
      /* harmony import */
      var core_js_modules_es6_array_from__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_array_from__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es6.function.name */"./node_modules/core-js/modules/es6.function.name.js");
      /* harmony import */
      var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */
      var core_js_modules_es6_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es6.object.to-string */"./node_modules/core-js/modules/es6.object.to-string.js");
      /* harmony import */
      var core_js_modules_es6_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */
      var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/web.dom.iterable */"./node_modules/core-js/modules/web.dom.iterable.js");
      /* harmony import */
      var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */
      var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es7.symbol.async-iterator */"./node_modules/core-js/modules/es7.symbol.async-iterator.js");
      /* harmony import */
      var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_4__);
      /* harmony import */
      var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! core-js/modules/es6.symbol */"./node_modules/core-js/modules/es6.symbol.js");
      /* harmony import */
      var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_5__);
      /* harmony import */
      var core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! core-js/modules/es6.regexp.split */"./node_modules/core-js/modules/es6.regexp.split.js");
      /* harmony import */
      var core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_6__);
      /* harmony import */
      var core_js_modules_es6_number_is_finite__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! core-js/modules/es6.number.is-finite */"./node_modules/core-js/modules/es6.number.is-finite.js");
      /* harmony import */
      var core_js_modules_es6_number_is_finite__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_number_is_finite__WEBPACK_IMPORTED_MODULE_7__);
      function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
      }
      function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }
      function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
      }
      function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for (var i = 0, arr2 = new Array(len); i < len; i++) {
          arr2[i] = arr[i];
        }
        return arr2;
      }
      function _iterableToArrayLimit(arr, i) {
        if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
          for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
          }
        } catch (err) {
          _d = true;
          _e = err;
        } finally {
          try {
            if (!_n && _i["return"] != null) _i["return"]();
          } finally {
            if (_d) throw _e;
          }
        }
        return _arr;
      }
      function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
      }
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }
      var HEADER_REGEXP = /([a-zA-Z][a-zA-Z_-]*)\s*(?:=(?:"([^"]*)"|([^ \t",;]*)))?/g;
      var STRINGS = {
        maxAge: 'max-age',
        sharedMaxAge: 's-maxage',
        maxStale: 'max-stale',
        minFresh: 'min-fresh',
        immutable: 'immutable',
        mustRevalidate: 'must-revalidate',
        noCache: 'no-cache',
        noStore: 'no-store',
        noTransform: 'no-transform',
        onlyIfCached: 'only-if-cached',
        "private": 'private',
        proxyRevalidate: 'proxy-revalidate',
        "public": 'public'
      };
      function parseBooleanOnly(value) {
        return value === null;
      }
      function parseDuration(value) {
        if (!value) {
          return null;
        }
        var duration = parseInt(value, 10);
        if (!Number.isFinite(duration) || duration < 0) {
          return null;
        }
        return duration;
      }
      var CacheControl = /*#__PURE__*/function () {
        function CacheControl() {
          _classCallCheck(this, CacheControl);
          this.maxAge = null;
          this.sharedMaxAge = null;
          this.maxStale = null;
          this.maxStaleDuration = null;
          this.minFresh = null;
          this.immutable = null;
          this.mustRevalidate = null;
          this.noCache = null;
          this.noStore = null;
          this.noTransform = null;
          this.onlyIfCached = null;
          this["private"] = null;
          this.proxyRevalidate = null;
          this["public"] = null;
        }
        _createClass(CacheControl, [{
          key: "parse",
          value: function parse(header) {
            if (!header || header.length === 0) {
              return this;
            }
            var values = {};
            var matches = header.match(HEADER_REGEXP) || [];
            Array.prototype.forEach.call(matches, function (match) {
              var tokens = match.split('=', 2);
              var _tokens = _slicedToArray(tokens, 1),
                key = _tokens[0];
              var value = null;
              if (tokens.length > 1) {
                value = tokens[1].trim();
              }
              values[key.toLowerCase()] = value;
            });
            this.maxAge = parseDuration(values[STRINGS.maxAge]);
            this.sharedMaxAge = parseDuration(values[STRINGS.sharedMaxAge]);
            this.maxStale = parseBooleanOnly(values[STRINGS.maxStale]);
            this.maxStaleDuration = parseDuration(values[STRINGS.maxStale]);
            if (this.maxStaleDuration) {
              this.maxStale = true;
            }
            this.minFresh = parseDuration(values[STRINGS.minFresh]);
            this.immutable = parseBooleanOnly(values[STRINGS.immutable]);
            this.mustRevalidate = parseBooleanOnly(values[STRINGS.mustRevalidate]);
            this.noCache = parseBooleanOnly(values[STRINGS.noCache]);
            this.noStore = parseBooleanOnly(values[STRINGS.noStore]);
            this.noTransform = parseBooleanOnly(values[STRINGS.noTransform]);
            this.onlyIfCached = parseBooleanOnly(values[STRINGS.onlyIfCached]);
            this["private"] = parseBooleanOnly(values[STRINGS["private"]]);
            this.proxyRevalidate = parseBooleanOnly(values[STRINGS.proxyRevalidate]);
            this["public"] = parseBooleanOnly(values[STRINGS["public"]]);
            return this;
          }
        }, {
          key: "format",
          value: function format() {
            var tokens = [];
            if (this.maxAge) {
              tokens.push("".concat(STRINGS.maxAge, "=").concat(this.maxAge));
            }
            if (this.sharedMaxAge) {
              tokens.push("".concat(STRINGS.sharedMaxAge, "=").concat(this.sharedMaxAge));
            }
            if (this.maxStale) {
              if (this.maxStaleDuration) {
                tokens.push("".concat(STRINGS.maxStale, "=").concat(this.maxStaleDuration));
              } else {
                tokens.push(STRINGS.maxStale);
              }
            }
            if (this.minFresh) {
              tokens.push("".concat(STRINGS.minFresh, "=").concat(this.minFresh));
            }
            if (this.immutable) {
              tokens.push(STRINGS.immutable);
            }
            if (this.mustRevalidate) {
              tokens.push(STRINGS.mustRevalidate);
            }
            if (this.noCache) {
              tokens.push(STRINGS.noCache);
            }
            if (this.noStore) {
              tokens.push(STRINGS.noStore);
            }
            if (this.noTransform) {
              tokens.push(STRINGS.noTransform);
            }
            if (this.onlyIfCached) {
              tokens.push(STRINGS.onlyIfCached);
            }
            if (this["private"]) {
              tokens.push(STRINGS["private"]);
            }
            if (this.proxyRevalidate) {
              tokens.push(STRINGS.proxyRevalidate);
            }
            if (this["public"]) {
              tokens.push(STRINGS["public"]);
            }
            return tokens.join(', ');
          }
        }]);
        return CacheControl;
      }();
      function parse(header) {
        var cc = new CacheControl();
        return cc.parse(header);
      }
      function format(cc) {
        if (!(cc instanceof CacheControl)) {
          return CacheControl.prototype.format.call(cc);
        }
        return cc.format();
      }

      /* harmony default export */
      __webpack_exports__["default"] = {
        CacheControl: CacheControl,
        parse: parse,
        format: format
      };

      /***/
    }),
    /***/"./node_modules/charenc/charenc.js": (
    /*!*****************************************!*\
      !*** ./node_modules/charenc/charenc.js ***!
      \*****************************************/
    /*! no static exports found */
    /***/
    function (module, exports) {
      var charenc = {
        // UTF-8 encoding
        utf8: {
          // Convert a string to a byte array
          stringToBytes: function (str) {
            return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
          },
          // Convert a byte array to a string
          bytesToString: function (bytes) {
            return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
          }
        },
        // Binary encoding
        bin: {
          // Convert a string to a byte array
          stringToBytes: function (str) {
            for (var bytes = [], i = 0; i < str.length; i++) bytes.push(str.charCodeAt(i) & 0xFF);
            return bytes;
          },
          // Convert a byte array to a string
          bytesToString: function (bytes) {
            for (var str = [], i = 0; i < bytes.length; i++) str.push(String.fromCharCode(bytes[i]));
            return str.join('');
          }
        }
      };
      module.exports = charenc;

      /***/
    }),
    /***/"./node_modules/core-js/modules/_a-function.js": (
    /*!*****************************************************!*\
      !*** ./node_modules/core-js/modules/_a-function.js ***!
      \*****************************************************/
    /*! no static exports found */
    /***/
    function (module, exports) {
      module.exports = function (it) {
        if (typeof it != 'function') throw TypeError(it + ' is not a function!');
        return it;
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_add-to-unscopables.js": (
    /*!*************************************************************!*\
      !*** ./node_modules/core-js/modules/_add-to-unscopables.js ***!
      \*************************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      // 22.1.3.31 Array.prototype[@@unscopables]
      var UNSCOPABLES = __webpack_require__(/*! ./_wks */"./node_modules/core-js/modules/_wks.js")('unscopables');
      var ArrayProto = Array.prototype;
      if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(/*! ./_hide */"./node_modules/core-js/modules/_hide.js")(ArrayProto, UNSCOPABLES, {});
      module.exports = function (key) {
        ArrayProto[UNSCOPABLES][key] = true;
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_advance-string-index.js": (
    /*!***************************************************************!*\
      !*** ./node_modules/core-js/modules/_advance-string-index.js ***!
      \***************************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var at = __webpack_require__(/*! ./_string-at */"./node_modules/core-js/modules/_string-at.js")(true);

      // `AdvanceStringIndex` abstract operation
      // https://tc39.github.io/ecma262/#sec-advancestringindex
      module.exports = function (S, index, unicode) {
        return index + (unicode ? at(S, index).length : 1);
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_an-object.js": (
    /*!****************************************************!*\
      !*** ./node_modules/core-js/modules/_an-object.js ***!
      \****************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      var isObject = __webpack_require__(/*! ./_is-object */"./node_modules/core-js/modules/_is-object.js");
      module.exports = function (it) {
        if (!isObject(it)) throw TypeError(it + ' is not an object!');
        return it;
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_array-includes.js": (
    /*!*********************************************************!*\
      !*** ./node_modules/core-js/modules/_array-includes.js ***!
      \*********************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      // false -> Array#indexOf
      // true  -> Array#includes
      var toIObject = __webpack_require__(/*! ./_to-iobject */"./node_modules/core-js/modules/_to-iobject.js");
      var toLength = __webpack_require__(/*! ./_to-length */"./node_modules/core-js/modules/_to-length.js");
      var toAbsoluteIndex = __webpack_require__(/*! ./_to-absolute-index */"./node_modules/core-js/modules/_to-absolute-index.js");
      module.exports = function (IS_INCLUDES) {
        return function ($this, el, fromIndex) {
          var O = toIObject($this);
          var length = toLength(O.length);
          var index = toAbsoluteIndex(fromIndex, length);
          var value;
          // Array#includes uses SameValueZero equality algorithm
          // eslint-disable-next-line no-self-compare
          if (IS_INCLUDES && el != el) while (length > index) {
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
            // Array#indexOf ignores holes, Array#includes - not
          } else for (; length > index; index++) if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
          }
          return !IS_INCLUDES && -1;
        };
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_classof.js": (
    /*!**************************************************!*\
      !*** ./node_modules/core-js/modules/_classof.js ***!
      \**************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      // getting tag from 19.1.3.6 Object.prototype.toString()
      var cof = __webpack_require__(/*! ./_cof */"./node_modules/core-js/modules/_cof.js");
      var TAG = __webpack_require__(/*! ./_wks */"./node_modules/core-js/modules/_wks.js")('toStringTag');
      // ES3 wrong here
      var ARG = cof(function () {
        return arguments;
      }()) == 'Arguments';

      // fallback for IE11 Script Access Denied error
      var tryGet = function (it, key) {
        try {
          return it[key];
        } catch (e) {/* empty */}
      };
      module.exports = function (it) {
        var O, T, B;
        return it === undefined ? 'Undefined' : it === null ? 'Null'
        // @@toStringTag case
        : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
        // builtinTag case
        : ARG ? cof(O)
        // ES3 arguments fallback
        : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_cof.js": (
    /*!**********************************************!*\
      !*** ./node_modules/core-js/modules/_cof.js ***!
      \**********************************************/
    /*! no static exports found */
    /***/
    function (module, exports) {
      var toString = {}.toString;
      module.exports = function (it) {
        return toString.call(it).slice(8, -1);
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_core.js": (
    /*!***********************************************!*\
      !*** ./node_modules/core-js/modules/_core.js ***!
      \***********************************************/
    /*! no static exports found */
    /***/
    function (module, exports) {
      var core = module.exports = {
        version: '2.6.12'
      };
      if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

      /***/
    }),
    /***/"./node_modules/core-js/modules/_create-property.js": (
    /*!**********************************************************!*\
      !*** ./node_modules/core-js/modules/_create-property.js ***!
      \**********************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var $defineProperty = __webpack_require__(/*! ./_object-dp */"./node_modules/core-js/modules/_object-dp.js");
      var createDesc = __webpack_require__(/*! ./_property-desc */"./node_modules/core-js/modules/_property-desc.js");
      module.exports = function (object, index, value) {
        if (index in object) $defineProperty.f(object, index, createDesc(0, value));else object[index] = value;
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_ctx.js": (
    /*!**********************************************!*\
      !*** ./node_modules/core-js/modules/_ctx.js ***!
      \**********************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      // optional / simple context binding
      var aFunction = __webpack_require__(/*! ./_a-function */"./node_modules/core-js/modules/_a-function.js");
      module.exports = function (fn, that, length) {
        aFunction(fn);
        if (that === undefined) return fn;
        switch (length) {
          case 1:
            return function (a) {
              return fn.call(that, a);
            };
          case 2:
            return function (a, b) {
              return fn.call(that, a, b);
            };
          case 3:
            return function (a, b, c) {
              return fn.call(that, a, b, c);
            };
        }
        return function /* ...args */
        () {
          return fn.apply(that, arguments);
        };
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_defined.js": (
    /*!**************************************************!*\
      !*** ./node_modules/core-js/modules/_defined.js ***!
      \**************************************************/
    /*! no static exports found */
    /***/
    function (module, exports) {
      // 7.2.1 RequireObjectCoercible(argument)
      module.exports = function (it) {
        if (it == undefined) throw TypeError("Can't call method on  " + it);
        return it;
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_descriptors.js": (
    /*!******************************************************!*\
      !*** ./node_modules/core-js/modules/_descriptors.js ***!
      \******************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      // Thank's IE8 for his funny defineProperty
      module.exports = !__webpack_require__(/*! ./_fails */"./node_modules/core-js/modules/_fails.js")(function () {
        return Object.defineProperty({}, 'a', {
          get: function () {
            return 7;
          }
        }).a != 7;
      });

      /***/
    }),
    /***/"./node_modules/core-js/modules/_dom-create.js": (
    /*!*****************************************************!*\
      !*** ./node_modules/core-js/modules/_dom-create.js ***!
      \*****************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      var isObject = __webpack_require__(/*! ./_is-object */"./node_modules/core-js/modules/_is-object.js");
      var document = __webpack_require__(/*! ./_global */"./node_modules/core-js/modules/_global.js").document;
      // typeof document.createElement is 'object' in old IE
      var is = isObject(document) && isObject(document.createElement);
      module.exports = function (it) {
        return is ? document.createElement(it) : {};
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_enum-bug-keys.js": (
    /*!********************************************************!*\
      !*** ./node_modules/core-js/modules/_enum-bug-keys.js ***!
      \********************************************************/
    /*! no static exports found */
    /***/
    function (module, exports) {
      // IE 8- don't enum bug keys
      module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

      /***/
    }),
    /***/"./node_modules/core-js/modules/_enum-keys.js": (
    /*!****************************************************!*\
      !*** ./node_modules/core-js/modules/_enum-keys.js ***!
      \****************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      // all enumerable object keys, includes symbols
      var getKeys = __webpack_require__(/*! ./_object-keys */"./node_modules/core-js/modules/_object-keys.js");
      var gOPS = __webpack_require__(/*! ./_object-gops */"./node_modules/core-js/modules/_object-gops.js");
      var pIE = __webpack_require__(/*! ./_object-pie */"./node_modules/core-js/modules/_object-pie.js");
      module.exports = function (it) {
        var result = getKeys(it);
        var getSymbols = gOPS.f;
        if (getSymbols) {
          var symbols = getSymbols(it);
          var isEnum = pIE.f;
          var i = 0;
          var key;
          while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
        }
        return result;
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_export.js": (
    /*!*************************************************!*\
      !*** ./node_modules/core-js/modules/_export.js ***!
      \*************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      var global = __webpack_require__(/*! ./_global */"./node_modules/core-js/modules/_global.js");
      var core = __webpack_require__(/*! ./_core */"./node_modules/core-js/modules/_core.js");
      var hide = __webpack_require__(/*! ./_hide */"./node_modules/core-js/modules/_hide.js");
      var redefine = __webpack_require__(/*! ./_redefine */"./node_modules/core-js/modules/_redefine.js");
      var ctx = __webpack_require__(/*! ./_ctx */"./node_modules/core-js/modules/_ctx.js");
      var PROTOTYPE = 'prototype';
      var $export = function (type, name, source) {
        var IS_FORCED = type & $export.F;
        var IS_GLOBAL = type & $export.G;
        var IS_STATIC = type & $export.S;
        var IS_PROTO = type & $export.P;
        var IS_BIND = type & $export.B;
        var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
        var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
        var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
        var key, own, out, exp;
        if (IS_GLOBAL) source = name;
        for (key in source) {
          // contains in native
          own = !IS_FORCED && target && target[key] !== undefined;
          // export native or passed
          out = (own ? target : source)[key];
          // bind timers to global for call from export context
          exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
          // extend global
          if (target) redefine(target, key, out, type & $export.U);
          // export
          if (exports[key] != out) hide(exports, key, exp);
          if (IS_PROTO && expProto[key] != out) expProto[key] = out;
        }
      };
      global.core = core;
      // type bitmap
      $export.F = 1; // forced
      $export.G = 2; // global
      $export.S = 4; // static
      $export.P = 8; // proto
      $export.B = 16; // bind
      $export.W = 32; // wrap
      $export.U = 64; // safe
      $export.R = 128; // real proto method for `library`
      module.exports = $export;

      /***/
    }),
    /***/"./node_modules/core-js/modules/_fails-is-regexp.js": (
    /*!**********************************************************!*\
      !*** ./node_modules/core-js/modules/_fails-is-regexp.js ***!
      \**********************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      var MATCH = __webpack_require__(/*! ./_wks */"./node_modules/core-js/modules/_wks.js")('match');
      module.exports = function (KEY) {
        var re = /./;
        try {
          '/./'[KEY](re);
        } catch (e) {
          try {
            re[MATCH] = false;
            return !'/./'[KEY](re);
          } catch (f) {/* empty */}
        }
        return true;
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_fails.js": (
    /*!************************************************!*\
      !*** ./node_modules/core-js/modules/_fails.js ***!
      \************************************************/
    /*! no static exports found */
    /***/
    function (module, exports) {
      module.exports = function (exec) {
        try {
          return !!exec();
        } catch (e) {
          return true;
        }
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_fix-re-wks.js": (
    /*!*****************************************************!*\
      !*** ./node_modules/core-js/modules/_fix-re-wks.js ***!
      \*****************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      __webpack_require__(/*! ./es6.regexp.exec */"./node_modules/core-js/modules/es6.regexp.exec.js");
      var redefine = __webpack_require__(/*! ./_redefine */"./node_modules/core-js/modules/_redefine.js");
      var hide = __webpack_require__(/*! ./_hide */"./node_modules/core-js/modules/_hide.js");
      var fails = __webpack_require__(/*! ./_fails */"./node_modules/core-js/modules/_fails.js");
      var defined = __webpack_require__(/*! ./_defined */"./node_modules/core-js/modules/_defined.js");
      var wks = __webpack_require__(/*! ./_wks */"./node_modules/core-js/modules/_wks.js");
      var regexpExec = __webpack_require__(/*! ./_regexp-exec */"./node_modules/core-js/modules/_regexp-exec.js");
      var SPECIES = wks('species');
      var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
        // #replace needs built-in support for named groups.
        // #match works fine because it just return the exec results, even if it has
        // a "grops" property.
        var re = /./;
        re.exec = function () {
          var result = [];
          result.groups = {
            a: '7'
          };
          return result;
        };
        return ''.replace(re, '$<a>') !== '7';
      });
      var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = function () {
        // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
        var re = /(?:)/;
        var originalExec = re.exec;
        re.exec = function () {
          return originalExec.apply(this, arguments);
        };
        var result = 'ab'.split(re);
        return result.length === 2 && result[0] === 'a' && result[1] === 'b';
      }();
      module.exports = function (KEY, length, exec) {
        var SYMBOL = wks(KEY);
        var DELEGATES_TO_SYMBOL = !fails(function () {
          // String methods call symbol-named RegEp methods
          var O = {};
          O[SYMBOL] = function () {
            return 7;
          };
          return ''[KEY](O) != 7;
        });
        var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
          // Symbol-named RegExp methods call .exec
          var execCalled = false;
          var re = /a/;
          re.exec = function () {
            execCalled = true;
            return null;
          };
          if (KEY === 'split') {
            // RegExp[@@split] doesn't call the regex's exec method, but first creates
            // a new one. We need to return the patched regex when creating the new one.
            re.constructor = {};
            re.constructor[SPECIES] = function () {
              return re;
            };
          }
          re[SYMBOL]('');
          return !execCalled;
        }) : undefined;
        if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS || KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC) {
          var nativeRegExpMethod = /./[SYMBOL];
          var fns = exec(defined, SYMBOL, ''[KEY], function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
            if (regexp.exec === regexpExec) {
              if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
                // The native String method already delegates to @@method (this
                // polyfilled function), leasing to infinite recursion.
                // We avoid it by directly calling the native @@method method.
                return {
                  done: true,
                  value: nativeRegExpMethod.call(regexp, str, arg2)
                };
              }
              return {
                done: true,
                value: nativeMethod.call(str, regexp, arg2)
              };
            }
            return {
              done: false
            };
          });
          var strfn = fns[0];
          var rxfn = fns[1];
          redefine(String.prototype, KEY, strfn);
          hide(RegExp.prototype, SYMBOL, length == 2
          // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
          // 21.2.5.11 RegExp.prototype[@@split](string, limit)
          ? function (string, arg) {
            return rxfn.call(string, this, arg);
          }
          // 21.2.5.6 RegExp.prototype[@@match](string)
          // 21.2.5.9 RegExp.prototype[@@search](string)
          : function (string) {
            return rxfn.call(string, this);
          });
        }
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_flags.js": (
    /*!************************************************!*\
      !*** ./node_modules/core-js/modules/_flags.js ***!
      \************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      // 21.2.5.3 get RegExp.prototype.flags
      var anObject = __webpack_require__(/*! ./_an-object */"./node_modules/core-js/modules/_an-object.js");
      module.exports = function () {
        var that = anObject(this);
        var result = '';
        if (that.global) result += 'g';
        if (that.ignoreCase) result += 'i';
        if (that.multiline) result += 'm';
        if (that.unicode) result += 'u';
        if (that.sticky) result += 'y';
        return result;
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_function-to-string.js": (
    /*!*************************************************************!*\
      !*** ./node_modules/core-js/modules/_function-to-string.js ***!
      \*************************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      module.exports = __webpack_require__(/*! ./_shared */"./node_modules/core-js/modules/_shared.js")('native-function-to-string', Function.toString);

      /***/
    }),
    /***/"./node_modules/core-js/modules/_global.js": (
    /*!*************************************************!*\
      !*** ./node_modules/core-js/modules/_global.js ***!
      \*************************************************/
    /*! no static exports found */
    /***/
    function (module, exports) {
      // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
      var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self
      // eslint-disable-next-line no-new-func
      : Function('return this')();
      if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

      /***/
    }),
    /***/"./node_modules/core-js/modules/_has.js": (
    /*!**********************************************!*\
      !*** ./node_modules/core-js/modules/_has.js ***!
      \**********************************************/
    /*! no static exports found */
    /***/
    function (module, exports) {
      var hasOwnProperty = {}.hasOwnProperty;
      module.exports = function (it, key) {
        return hasOwnProperty.call(it, key);
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_hide.js": (
    /*!***********************************************!*\
      !*** ./node_modules/core-js/modules/_hide.js ***!
      \***********************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      var dP = __webpack_require__(/*! ./_object-dp */"./node_modules/core-js/modules/_object-dp.js");
      var createDesc = __webpack_require__(/*! ./_property-desc */"./node_modules/core-js/modules/_property-desc.js");
      module.exports = __webpack_require__(/*! ./_descriptors */"./node_modules/core-js/modules/_descriptors.js") ? function (object, key, value) {
        return dP.f(object, key, createDesc(1, value));
      } : function (object, key, value) {
        object[key] = value;
        return object;
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_html.js": (
    /*!***********************************************!*\
      !*** ./node_modules/core-js/modules/_html.js ***!
      \***********************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      var document = __webpack_require__(/*! ./_global */"./node_modules/core-js/modules/_global.js").document;
      module.exports = document && document.documentElement;

      /***/
    }),
    /***/"./node_modules/core-js/modules/_ie8-dom-define.js": (
    /*!*********************************************************!*\
      !*** ./node_modules/core-js/modules/_ie8-dom-define.js ***!
      \*********************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      module.exports = !__webpack_require__(/*! ./_descriptors */"./node_modules/core-js/modules/_descriptors.js") && !__webpack_require__(/*! ./_fails */"./node_modules/core-js/modules/_fails.js")(function () {
        return Object.defineProperty(__webpack_require__(/*! ./_dom-create */"./node_modules/core-js/modules/_dom-create.js")('div'), 'a', {
          get: function () {
            return 7;
          }
        }).a != 7;
      });

      /***/
    }),
    /***/"./node_modules/core-js/modules/_iobject.js": (
    /*!**************************************************!*\
      !*** ./node_modules/core-js/modules/_iobject.js ***!
      \**************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      // fallback for non-array-like ES3 and non-enumerable old V8 strings
      var cof = __webpack_require__(/*! ./_cof */"./node_modules/core-js/modules/_cof.js");
      // eslint-disable-next-line no-prototype-builtins
      module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
        return cof(it) == 'String' ? it.split('') : Object(it);
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_is-array-iter.js": (
    /*!********************************************************!*\
      !*** ./node_modules/core-js/modules/_is-array-iter.js ***!
      \********************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      // check on default Array iterator
      var Iterators = __webpack_require__(/*! ./_iterators */"./node_modules/core-js/modules/_iterators.js");
      var ITERATOR = __webpack_require__(/*! ./_wks */"./node_modules/core-js/modules/_wks.js")('iterator');
      var ArrayProto = Array.prototype;
      module.exports = function (it) {
        return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_is-array.js": (
    /*!***************************************************!*\
      !*** ./node_modules/core-js/modules/_is-array.js ***!
      \***************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      // 7.2.2 IsArray(argument)
      var cof = __webpack_require__(/*! ./_cof */"./node_modules/core-js/modules/_cof.js");
      module.exports = Array.isArray || function isArray(arg) {
        return cof(arg) == 'Array';
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_is-object.js": (
    /*!****************************************************!*\
      !*** ./node_modules/core-js/modules/_is-object.js ***!
      \****************************************************/
    /*! no static exports found */
    /***/
    function (module, exports) {
      module.exports = function (it) {
        return typeof it === 'object' ? it !== null : typeof it === 'function';
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_is-regexp.js": (
    /*!****************************************************!*\
      !*** ./node_modules/core-js/modules/_is-regexp.js ***!
      \****************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      // 7.2.8 IsRegExp(argument)
      var isObject = __webpack_require__(/*! ./_is-object */"./node_modules/core-js/modules/_is-object.js");
      var cof = __webpack_require__(/*! ./_cof */"./node_modules/core-js/modules/_cof.js");
      var MATCH = __webpack_require__(/*! ./_wks */"./node_modules/core-js/modules/_wks.js")('match');
      module.exports = function (it) {
        var isRegExp;
        return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_iter-call.js": (
    /*!****************************************************!*\
      !*** ./node_modules/core-js/modules/_iter-call.js ***!
      \****************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      // call something on iterator step with safe closing on error
      var anObject = __webpack_require__(/*! ./_an-object */"./node_modules/core-js/modules/_an-object.js");
      module.exports = function (iterator, fn, value, entries) {
        try {
          return entries ? fn(anObject(value)[0], value[1]) : fn(value);
          // 7.4.6 IteratorClose(iterator, completion)
        } catch (e) {
          var ret = iterator['return'];
          if (ret !== undefined) anObject(ret.call(iterator));
          throw e;
        }
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_iter-create.js": (
    /*!******************************************************!*\
      !*** ./node_modules/core-js/modules/_iter-create.js ***!
      \******************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var create = __webpack_require__(/*! ./_object-create */"./node_modules/core-js/modules/_object-create.js");
      var descriptor = __webpack_require__(/*! ./_property-desc */"./node_modules/core-js/modules/_property-desc.js");
      var setToStringTag = __webpack_require__(/*! ./_set-to-string-tag */"./node_modules/core-js/modules/_set-to-string-tag.js");
      var IteratorPrototype = {};

      // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
      __webpack_require__(/*! ./_hide */"./node_modules/core-js/modules/_hide.js")(IteratorPrototype, __webpack_require__(/*! ./_wks */"./node_modules/core-js/modules/_wks.js")('iterator'), function () {
        return this;
      });
      module.exports = function (Constructor, NAME, next) {
        Constructor.prototype = create(IteratorPrototype, {
          next: descriptor(1, next)
        });
        setToStringTag(Constructor, NAME + ' Iterator');
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_iter-define.js": (
    /*!******************************************************!*\
      !*** ./node_modules/core-js/modules/_iter-define.js ***!
      \******************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var LIBRARY = __webpack_require__(/*! ./_library */"./node_modules/core-js/modules/_library.js");
      var $export = __webpack_require__(/*! ./_export */"./node_modules/core-js/modules/_export.js");
      var redefine = __webpack_require__(/*! ./_redefine */"./node_modules/core-js/modules/_redefine.js");
      var hide = __webpack_require__(/*! ./_hide */"./node_modules/core-js/modules/_hide.js");
      var Iterators = __webpack_require__(/*! ./_iterators */"./node_modules/core-js/modules/_iterators.js");
      var $iterCreate = __webpack_require__(/*! ./_iter-create */"./node_modules/core-js/modules/_iter-create.js");
      var setToStringTag = __webpack_require__(/*! ./_set-to-string-tag */"./node_modules/core-js/modules/_set-to-string-tag.js");
      var getPrototypeOf = __webpack_require__(/*! ./_object-gpo */"./node_modules/core-js/modules/_object-gpo.js");
      var ITERATOR = __webpack_require__(/*! ./_wks */"./node_modules/core-js/modules/_wks.js")('iterator');
      var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
      var FF_ITERATOR = '@@iterator';
      var KEYS = 'keys';
      var VALUES = 'values';
      var returnThis = function () {
        return this;
      };
      module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
        $iterCreate(Constructor, NAME, next);
        var getMethod = function (kind) {
          if (!BUGGY && kind in proto) return proto[kind];
          switch (kind) {
            case KEYS:
              return function keys() {
                return new Constructor(this, kind);
              };
            case VALUES:
              return function values() {
                return new Constructor(this, kind);
              };
          }
          return function entries() {
            return new Constructor(this, kind);
          };
        };
        var TAG = NAME + ' Iterator';
        var DEF_VALUES = DEFAULT == VALUES;
        var VALUES_BUG = false;
        var proto = Base.prototype;
        var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
        var $default = $native || getMethod(DEFAULT);
        var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
        var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
        var methods, key, IteratorPrototype;
        // Fix native
        if ($anyNative) {
          IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
          if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            setToStringTag(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
          }
        }
        // fix Array#{values, @@iterator}.name in V8 / FF
        if (DEF_VALUES && $native && $native.name !== VALUES) {
          VALUES_BUG = true;
          $default = function values() {
            return $native.call(this);
          };
        }
        // Define iterator
        if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
          hide(proto, ITERATOR, $default);
        }
        // Plug for library
        Iterators[NAME] = $default;
        Iterators[TAG] = returnThis;
        if (DEFAULT) {
          methods = {
            values: DEF_VALUES ? $default : getMethod(VALUES),
            keys: IS_SET ? $default : getMethod(KEYS),
            entries: $entries
          };
          if (FORCED) for (key in methods) {
            if (!(key in proto)) redefine(proto, key, methods[key]);
          } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
        }
        return methods;
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_iter-detect.js": (
    /*!******************************************************!*\
      !*** ./node_modules/core-js/modules/_iter-detect.js ***!
      \******************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      var ITERATOR = __webpack_require__(/*! ./_wks */"./node_modules/core-js/modules/_wks.js")('iterator');
      var SAFE_CLOSING = false;
      try {
        var riter = [7][ITERATOR]();
        riter['return'] = function () {
          SAFE_CLOSING = true;
        };
        // eslint-disable-next-line no-throw-literal
        Array.from(riter, function () {
          throw 2;
        });
      } catch (e) {/* empty */}
      module.exports = function (exec, skipClosing) {
        if (!skipClosing && !SAFE_CLOSING) return false;
        var safe = false;
        try {
          var arr = [7];
          var iter = arr[ITERATOR]();
          iter.next = function () {
            return {
              done: safe = true
            };
          };
          arr[ITERATOR] = function () {
            return iter;
          };
          exec(arr);
        } catch (e) {/* empty */}
        return safe;
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_iter-step.js": (
    /*!****************************************************!*\
      !*** ./node_modules/core-js/modules/_iter-step.js ***!
      \****************************************************/
    /*! no static exports found */
    /***/
    function (module, exports) {
      module.exports = function (done, value) {
        return {
          value: value,
          done: !!done
        };
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_iterators.js": (
    /*!****************************************************!*\
      !*** ./node_modules/core-js/modules/_iterators.js ***!
      \****************************************************/
    /*! no static exports found */
    /***/
    function (module, exports) {
      module.exports = {};

      /***/
    }),
    /***/"./node_modules/core-js/modules/_library.js": (
    /*!**************************************************!*\
      !*** ./node_modules/core-js/modules/_library.js ***!
      \**************************************************/
    /*! no static exports found */
    /***/
    function (module, exports) {
      module.exports = false;

      /***/
    }),
    /***/"./node_modules/core-js/modules/_meta.js": (
    /*!***********************************************!*\
      !*** ./node_modules/core-js/modules/_meta.js ***!
      \***********************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      var META = __webpack_require__(/*! ./_uid */"./node_modules/core-js/modules/_uid.js")('meta');
      var isObject = __webpack_require__(/*! ./_is-object */"./node_modules/core-js/modules/_is-object.js");
      var has = __webpack_require__(/*! ./_has */"./node_modules/core-js/modules/_has.js");
      var setDesc = __webpack_require__(/*! ./_object-dp */"./node_modules/core-js/modules/_object-dp.js").f;
      var id = 0;
      var isExtensible = Object.isExtensible || function () {
        return true;
      };
      var FREEZE = !__webpack_require__(/*! ./_fails */"./node_modules/core-js/modules/_fails.js")(function () {
        return isExtensible(Object.preventExtensions({}));
      });
      var setMeta = function (it) {
        setDesc(it, META, {
          value: {
            i: 'O' + ++id,
            // object ID
            w: {} // weak collections IDs
          }
        });
      };
      var fastKey = function (it, create) {
        // return primitive with prefix
        if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
        if (!has(it, META)) {
          // can't set metadata to uncaught frozen object
          if (!isExtensible(it)) return 'F';
          // not necessary to add metadata
          if (!create) return 'E';
          // add missing metadata
          setMeta(it);
          // return object ID
        }
        return it[META].i;
      };
      var getWeak = function (it, create) {
        if (!has(it, META)) {
          // can't set metadata to uncaught frozen object
          if (!isExtensible(it)) return true;
          // not necessary to add metadata
          if (!create) return false;
          // add missing metadata
          setMeta(it);
          // return hash weak collections IDs
        }
        return it[META].w;
      };
      // add metadata on freeze-family methods calling
      var onFreeze = function (it) {
        if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
        return it;
      };
      var meta = module.exports = {
        KEY: META,
        NEED: false,
        fastKey: fastKey,
        getWeak: getWeak,
        onFreeze: onFreeze
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_object-create.js": (
    /*!********************************************************!*\
      !*** ./node_modules/core-js/modules/_object-create.js ***!
      \********************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
      var anObject = __webpack_require__(/*! ./_an-object */"./node_modules/core-js/modules/_an-object.js");
      var dPs = __webpack_require__(/*! ./_object-dps */"./node_modules/core-js/modules/_object-dps.js");
      var enumBugKeys = __webpack_require__(/*! ./_enum-bug-keys */"./node_modules/core-js/modules/_enum-bug-keys.js");
      var IE_PROTO = __webpack_require__(/*! ./_shared-key */"./node_modules/core-js/modules/_shared-key.js")('IE_PROTO');
      var Empty = function () {/* empty */};
      var PROTOTYPE = 'prototype';

      // Create object with fake `null` prototype: use iframe Object with cleared prototype
      var createDict = function () {
        // Thrash, waste and sodomy: IE GC bug
        var iframe = __webpack_require__(/*! ./_dom-create */"./node_modules/core-js/modules/_dom-create.js")('iframe');
        var i = enumBugKeys.length;
        var lt = '<';
        var gt = '>';
        var iframeDocument;
        iframe.style.display = 'none';
        __webpack_require__(/*! ./_html */"./node_modules/core-js/modules/_html.js").appendChild(iframe);
        iframe.src = 'javascript:'; // eslint-disable-line no-script-url
        // createDict = iframe.contentWindow.Object;
        // html.removeChild(iframe);
        iframeDocument = iframe.contentWindow.document;
        iframeDocument.open();
        iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
        iframeDocument.close();
        createDict = iframeDocument.F;
        while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
        return createDict();
      };
      module.exports = Object.create || function create(O, Properties) {
        var result;
        if (O !== null) {
          Empty[PROTOTYPE] = anObject(O);
          result = new Empty();
          Empty[PROTOTYPE] = null;
          // add "__proto__" for Object.getPrototypeOf polyfill
          result[IE_PROTO] = O;
        } else result = createDict();
        return Properties === undefined ? result : dPs(result, Properties);
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_object-dp.js": (
    /*!****************************************************!*\
      !*** ./node_modules/core-js/modules/_object-dp.js ***!
      \****************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      var anObject = __webpack_require__(/*! ./_an-object */"./node_modules/core-js/modules/_an-object.js");
      var IE8_DOM_DEFINE = __webpack_require__(/*! ./_ie8-dom-define */"./node_modules/core-js/modules/_ie8-dom-define.js");
      var toPrimitive = __webpack_require__(/*! ./_to-primitive */"./node_modules/core-js/modules/_to-primitive.js");
      var dP = Object.defineProperty;
      exports.f = __webpack_require__(/*! ./_descriptors */"./node_modules/core-js/modules/_descriptors.js") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
        anObject(O);
        P = toPrimitive(P, true);
        anObject(Attributes);
        if (IE8_DOM_DEFINE) try {
          return dP(O, P, Attributes);
        } catch (e) {/* empty */}
        if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
        if ('value' in Attributes) O[P] = Attributes.value;
        return O;
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_object-dps.js": (
    /*!*****************************************************!*\
      !*** ./node_modules/core-js/modules/_object-dps.js ***!
      \*****************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      var dP = __webpack_require__(/*! ./_object-dp */"./node_modules/core-js/modules/_object-dp.js");
      var anObject = __webpack_require__(/*! ./_an-object */"./node_modules/core-js/modules/_an-object.js");
      var getKeys = __webpack_require__(/*! ./_object-keys */"./node_modules/core-js/modules/_object-keys.js");
      module.exports = __webpack_require__(/*! ./_descriptors */"./node_modules/core-js/modules/_descriptors.js") ? Object.defineProperties : function defineProperties(O, Properties) {
        anObject(O);
        var keys = getKeys(Properties);
        var length = keys.length;
        var i = 0;
        var P;
        while (length > i) dP.f(O, P = keys[i++], Properties[P]);
        return O;
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_object-gopd.js": (
    /*!******************************************************!*\
      !*** ./node_modules/core-js/modules/_object-gopd.js ***!
      \******************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      var pIE = __webpack_require__(/*! ./_object-pie */"./node_modules/core-js/modules/_object-pie.js");
      var createDesc = __webpack_require__(/*! ./_property-desc */"./node_modules/core-js/modules/_property-desc.js");
      var toIObject = __webpack_require__(/*! ./_to-iobject */"./node_modules/core-js/modules/_to-iobject.js");
      var toPrimitive = __webpack_require__(/*! ./_to-primitive */"./node_modules/core-js/modules/_to-primitive.js");
      var has = __webpack_require__(/*! ./_has */"./node_modules/core-js/modules/_has.js");
      var IE8_DOM_DEFINE = __webpack_require__(/*! ./_ie8-dom-define */"./node_modules/core-js/modules/_ie8-dom-define.js");
      var gOPD = Object.getOwnPropertyDescriptor;
      exports.f = __webpack_require__(/*! ./_descriptors */"./node_modules/core-js/modules/_descriptors.js") ? gOPD : function getOwnPropertyDescriptor(O, P) {
        O = toIObject(O);
        P = toPrimitive(P, true);
        if (IE8_DOM_DEFINE) try {
          return gOPD(O, P);
        } catch (e) {/* empty */}
        if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_object-gopn-ext.js": (
    /*!**********************************************************!*\
      !*** ./node_modules/core-js/modules/_object-gopn-ext.js ***!
      \**********************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
      var toIObject = __webpack_require__(/*! ./_to-iobject */"./node_modules/core-js/modules/_to-iobject.js");
      var gOPN = __webpack_require__(/*! ./_object-gopn */"./node_modules/core-js/modules/_object-gopn.js").f;
      var toString = {}.toString;
      var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
      var getWindowNames = function (it) {
        try {
          return gOPN(it);
        } catch (e) {
          return windowNames.slice();
        }
      };
      module.exports.f = function getOwnPropertyNames(it) {
        return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_object-gopn.js": (
    /*!******************************************************!*\
      !*** ./node_modules/core-js/modules/_object-gopn.js ***!
      \******************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
      var $keys = __webpack_require__(/*! ./_object-keys-internal */"./node_modules/core-js/modules/_object-keys-internal.js");
      var hiddenKeys = __webpack_require__(/*! ./_enum-bug-keys */"./node_modules/core-js/modules/_enum-bug-keys.js").concat('length', 'prototype');
      exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
        return $keys(O, hiddenKeys);
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_object-gops.js": (
    /*!******************************************************!*\
      !*** ./node_modules/core-js/modules/_object-gops.js ***!
      \******************************************************/
    /*! no static exports found */
    /***/
    function (module, exports) {
      exports.f = Object.getOwnPropertySymbols;

      /***/
    }),
    /***/"./node_modules/core-js/modules/_object-gpo.js": (
    /*!*****************************************************!*\
      !*** ./node_modules/core-js/modules/_object-gpo.js ***!
      \*****************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
      var has = __webpack_require__(/*! ./_has */"./node_modules/core-js/modules/_has.js");
      var toObject = __webpack_require__(/*! ./_to-object */"./node_modules/core-js/modules/_to-object.js");
      var IE_PROTO = __webpack_require__(/*! ./_shared-key */"./node_modules/core-js/modules/_shared-key.js")('IE_PROTO');
      var ObjectProto = Object.prototype;
      module.exports = Object.getPrototypeOf || function (O) {
        O = toObject(O);
        if (has(O, IE_PROTO)) return O[IE_PROTO];
        if (typeof O.constructor == 'function' && O instanceof O.constructor) {
          return O.constructor.prototype;
        }
        return O instanceof Object ? ObjectProto : null;
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_object-keys-internal.js": (
    /*!***************************************************************!*\
      !*** ./node_modules/core-js/modules/_object-keys-internal.js ***!
      \***************************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      var has = __webpack_require__(/*! ./_has */"./node_modules/core-js/modules/_has.js");
      var toIObject = __webpack_require__(/*! ./_to-iobject */"./node_modules/core-js/modules/_to-iobject.js");
      var arrayIndexOf = __webpack_require__(/*! ./_array-includes */"./node_modules/core-js/modules/_array-includes.js")(false);
      var IE_PROTO = __webpack_require__(/*! ./_shared-key */"./node_modules/core-js/modules/_shared-key.js")('IE_PROTO');
      module.exports = function (object, names) {
        var O = toIObject(object);
        var i = 0;
        var result = [];
        var key;
        for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
        // Don't enum bug & hidden keys
        while (names.length > i) if (has(O, key = names[i++])) {
          ~arrayIndexOf(result, key) || result.push(key);
        }
        return result;
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_object-keys.js": (
    /*!******************************************************!*\
      !*** ./node_modules/core-js/modules/_object-keys.js ***!
      \******************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      // 19.1.2.14 / 15.2.3.14 Object.keys(O)
      var $keys = __webpack_require__(/*! ./_object-keys-internal */"./node_modules/core-js/modules/_object-keys-internal.js");
      var enumBugKeys = __webpack_require__(/*! ./_enum-bug-keys */"./node_modules/core-js/modules/_enum-bug-keys.js");
      module.exports = Object.keys || function keys(O) {
        return $keys(O, enumBugKeys);
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_object-pie.js": (
    /*!*****************************************************!*\
      !*** ./node_modules/core-js/modules/_object-pie.js ***!
      \*****************************************************/
    /*! no static exports found */
    /***/
    function (module, exports) {
      exports.f = {}.propertyIsEnumerable;

      /***/
    }),
    /***/"./node_modules/core-js/modules/_own-keys.js": (
    /*!***************************************************!*\
      !*** ./node_modules/core-js/modules/_own-keys.js ***!
      \***************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      // all object keys, includes non-enumerable and symbols
      var gOPN = __webpack_require__(/*! ./_object-gopn */"./node_modules/core-js/modules/_object-gopn.js");
      var gOPS = __webpack_require__(/*! ./_object-gops */"./node_modules/core-js/modules/_object-gops.js");
      var anObject = __webpack_require__(/*! ./_an-object */"./node_modules/core-js/modules/_an-object.js");
      var Reflect = __webpack_require__(/*! ./_global */"./node_modules/core-js/modules/_global.js").Reflect;
      module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
        var keys = gOPN.f(anObject(it));
        var getSymbols = gOPS.f;
        return getSymbols ? keys.concat(getSymbols(it)) : keys;
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_property-desc.js": (
    /*!********************************************************!*\
      !*** ./node_modules/core-js/modules/_property-desc.js ***!
      \********************************************************/
    /*! no static exports found */
    /***/
    function (module, exports) {
      module.exports = function (bitmap, value) {
        return {
          enumerable: !(bitmap & 1),
          configurable: !(bitmap & 2),
          writable: !(bitmap & 4),
          value: value
        };
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_redefine.js": (
    /*!***************************************************!*\
      !*** ./node_modules/core-js/modules/_redefine.js ***!
      \***************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      var global = __webpack_require__(/*! ./_global */"./node_modules/core-js/modules/_global.js");
      var hide = __webpack_require__(/*! ./_hide */"./node_modules/core-js/modules/_hide.js");
      var has = __webpack_require__(/*! ./_has */"./node_modules/core-js/modules/_has.js");
      var SRC = __webpack_require__(/*! ./_uid */"./node_modules/core-js/modules/_uid.js")('src');
      var $toString = __webpack_require__(/*! ./_function-to-string */"./node_modules/core-js/modules/_function-to-string.js");
      var TO_STRING = 'toString';
      var TPL = ('' + $toString).split(TO_STRING);
      __webpack_require__(/*! ./_core */"./node_modules/core-js/modules/_core.js").inspectSource = function (it) {
        return $toString.call(it);
      };
      (module.exports = function (O, key, val, safe) {
        var isFunction = typeof val == 'function';
        if (isFunction) has(val, 'name') || hide(val, 'name', key);
        if (O[key] === val) return;
        if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
        if (O === global) {
          O[key] = val;
        } else if (!safe) {
          delete O[key];
          hide(O, key, val);
        } else if (O[key]) {
          O[key] = val;
        } else {
          hide(O, key, val);
        }
        // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
      })(Function.prototype, TO_STRING, function toString() {
        return typeof this == 'function' && this[SRC] || $toString.call(this);
      });

      /***/
    }),
    /***/"./node_modules/core-js/modules/_regexp-exec-abstract.js": (
    /*!***************************************************************!*\
      !*** ./node_modules/core-js/modules/_regexp-exec-abstract.js ***!
      \***************************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var classof = __webpack_require__(/*! ./_classof */"./node_modules/core-js/modules/_classof.js");
      var builtinExec = RegExp.prototype.exec;

      // `RegExpExec` abstract operation
      // https://tc39.github.io/ecma262/#sec-regexpexec
      module.exports = function (R, S) {
        var exec = R.exec;
        if (typeof exec === 'function') {
          var result = exec.call(R, S);
          if (typeof result !== 'object') {
            throw new TypeError('RegExp exec method returned something other than an Object or null');
          }
          return result;
        }
        if (classof(R) !== 'RegExp') {
          throw new TypeError('RegExp#exec called on incompatible receiver');
        }
        return builtinExec.call(R, S);
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_regexp-exec.js": (
    /*!******************************************************!*\
      !*** ./node_modules/core-js/modules/_regexp-exec.js ***!
      \******************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var regexpFlags = __webpack_require__(/*! ./_flags */"./node_modules/core-js/modules/_flags.js");
      var nativeExec = RegExp.prototype.exec;
      // This always refers to the native implementation, because the
      // String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
      // which loads this file before patching the method.
      var nativeReplace = String.prototype.replace;
      var patchedExec = nativeExec;
      var LAST_INDEX = 'lastIndex';
      var UPDATES_LAST_INDEX_WRONG = function () {
        var re1 = /a/,
          re2 = /b*/g;
        nativeExec.call(re1, 'a');
        nativeExec.call(re2, 'a');
        return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
      }();

      // nonparticipating capturing group, copied from es5-shim's String#split patch.
      var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
      var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
      if (PATCH) {
        patchedExec = function exec(str) {
          var re = this;
          var lastIndex, reCopy, match, i;
          if (NPCG_INCLUDED) {
            reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
          }
          if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
          match = nativeExec.call(re, str);
          if (UPDATES_LAST_INDEX_WRONG && match) {
            re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
          }
          if (NPCG_INCLUDED && match && match.length > 1) {
            // Fix browsers whose `exec` methods don't consistently return `undefined`
            // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
            // eslint-disable-next-line no-loop-func
            nativeReplace.call(match[0], reCopy, function () {
              for (i = 1; i < arguments.length - 2; i++) {
                if (arguments[i] === undefined) match[i] = undefined;
              }
            });
          }
          return match;
        };
      }
      module.exports = patchedExec;

      /***/
    }),
    /***/"./node_modules/core-js/modules/_set-to-string-tag.js": (
    /*!************************************************************!*\
      !*** ./node_modules/core-js/modules/_set-to-string-tag.js ***!
      \************************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      var def = __webpack_require__(/*! ./_object-dp */"./node_modules/core-js/modules/_object-dp.js").f;
      var has = __webpack_require__(/*! ./_has */"./node_modules/core-js/modules/_has.js");
      var TAG = __webpack_require__(/*! ./_wks */"./node_modules/core-js/modules/_wks.js")('toStringTag');
      module.exports = function (it, tag, stat) {
        if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, {
          configurable: true,
          value: tag
        });
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_shared-key.js": (
    /*!*****************************************************!*\
      !*** ./node_modules/core-js/modules/_shared-key.js ***!
      \*****************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      var shared = __webpack_require__(/*! ./_shared */"./node_modules/core-js/modules/_shared.js")('keys');
      var uid = __webpack_require__(/*! ./_uid */"./node_modules/core-js/modules/_uid.js");
      module.exports = function (key) {
        return shared[key] || (shared[key] = uid(key));
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_shared.js": (
    /*!*************************************************!*\
      !*** ./node_modules/core-js/modules/_shared.js ***!
      \*************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      var core = __webpack_require__(/*! ./_core */"./node_modules/core-js/modules/_core.js");
      var global = __webpack_require__(/*! ./_global */"./node_modules/core-js/modules/_global.js");
      var SHARED = '__core-js_shared__';
      var store = global[SHARED] || (global[SHARED] = {});
      (module.exports = function (key, value) {
        return store[key] || (store[key] = value !== undefined ? value : {});
      })('versions', []).push({
        version: core.version,
        mode: __webpack_require__(/*! ./_library */"./node_modules/core-js/modules/_library.js") ? 'pure' : 'global',
        copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
      });

      /***/
    }),
    /***/"./node_modules/core-js/modules/_species-constructor.js": (
    /*!**************************************************************!*\
      !*** ./node_modules/core-js/modules/_species-constructor.js ***!
      \**************************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      // 7.3.20 SpeciesConstructor(O, defaultConstructor)
      var anObject = __webpack_require__(/*! ./_an-object */"./node_modules/core-js/modules/_an-object.js");
      var aFunction = __webpack_require__(/*! ./_a-function */"./node_modules/core-js/modules/_a-function.js");
      var SPECIES = __webpack_require__(/*! ./_wks */"./node_modules/core-js/modules/_wks.js")('species');
      module.exports = function (O, D) {
        var C = anObject(O).constructor;
        var S;
        return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_string-at.js": (
    /*!****************************************************!*\
      !*** ./node_modules/core-js/modules/_string-at.js ***!
      \****************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      var toInteger = __webpack_require__(/*! ./_to-integer */"./node_modules/core-js/modules/_to-integer.js");
      var defined = __webpack_require__(/*! ./_defined */"./node_modules/core-js/modules/_defined.js");
      // true  -> String#at
      // false -> String#codePointAt
      module.exports = function (TO_STRING) {
        return function (that, pos) {
          var s = String(defined(that));
          var i = toInteger(pos);
          var l = s.length;
          var a, b;
          if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
          a = s.charCodeAt(i);
          return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
        };
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_string-context.js": (
    /*!*********************************************************!*\
      !*** ./node_modules/core-js/modules/_string-context.js ***!
      \*********************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      // helper for String#{startsWith, endsWith, includes}
      var isRegExp = __webpack_require__(/*! ./_is-regexp */"./node_modules/core-js/modules/_is-regexp.js");
      var defined = __webpack_require__(/*! ./_defined */"./node_modules/core-js/modules/_defined.js");
      module.exports = function (that, searchString, NAME) {
        if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
        return String(defined(that));
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_to-absolute-index.js": (
    /*!************************************************************!*\
      !*** ./node_modules/core-js/modules/_to-absolute-index.js ***!
      \************************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      var toInteger = __webpack_require__(/*! ./_to-integer */"./node_modules/core-js/modules/_to-integer.js");
      var max = Math.max;
      var min = Math.min;
      module.exports = function (index, length) {
        index = toInteger(index);
        return index < 0 ? max(index + length, 0) : min(index, length);
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_to-integer.js": (
    /*!*****************************************************!*\
      !*** ./node_modules/core-js/modules/_to-integer.js ***!
      \*****************************************************/
    /*! no static exports found */
    /***/
    function (module, exports) {
      // 7.1.4 ToInteger
      var ceil = Math.ceil;
      var floor = Math.floor;
      module.exports = function (it) {
        return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_to-iobject.js": (
    /*!*****************************************************!*\
      !*** ./node_modules/core-js/modules/_to-iobject.js ***!
      \*****************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      // to indexed object, toObject with fallback for non-array-like ES3 strings
      var IObject = __webpack_require__(/*! ./_iobject */"./node_modules/core-js/modules/_iobject.js");
      var defined = __webpack_require__(/*! ./_defined */"./node_modules/core-js/modules/_defined.js");
      module.exports = function (it) {
        return IObject(defined(it));
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_to-length.js": (
    /*!****************************************************!*\
      !*** ./node_modules/core-js/modules/_to-length.js ***!
      \****************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      // 7.1.15 ToLength
      var toInteger = __webpack_require__(/*! ./_to-integer */"./node_modules/core-js/modules/_to-integer.js");
      var min = Math.min;
      module.exports = function (it) {
        return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_to-object.js": (
    /*!****************************************************!*\
      !*** ./node_modules/core-js/modules/_to-object.js ***!
      \****************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      // 7.1.13 ToObject(argument)
      var defined = __webpack_require__(/*! ./_defined */"./node_modules/core-js/modules/_defined.js");
      module.exports = function (it) {
        return Object(defined(it));
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_to-primitive.js": (
    /*!*******************************************************!*\
      !*** ./node_modules/core-js/modules/_to-primitive.js ***!
      \*******************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      // 7.1.1 ToPrimitive(input [, PreferredType])
      var isObject = __webpack_require__(/*! ./_is-object */"./node_modules/core-js/modules/_is-object.js");
      // instead of the ES6 spec version, we didn't implement @@toPrimitive case
      // and the second argument - flag - preferred type is a string
      module.exports = function (it, S) {
        if (!isObject(it)) return it;
        var fn, val;
        if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
        if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
        if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
        throw TypeError("Can't convert object to primitive value");
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_uid.js": (
    /*!**********************************************!*\
      !*** ./node_modules/core-js/modules/_uid.js ***!
      \**********************************************/
    /*! no static exports found */
    /***/
    function (module, exports) {
      var id = 0;
      var px = Math.random();
      module.exports = function (key) {
        return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_wks-define.js": (
    /*!*****************************************************!*\
      !*** ./node_modules/core-js/modules/_wks-define.js ***!
      \*****************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      var global = __webpack_require__(/*! ./_global */"./node_modules/core-js/modules/_global.js");
      var core = __webpack_require__(/*! ./_core */"./node_modules/core-js/modules/_core.js");
      var LIBRARY = __webpack_require__(/*! ./_library */"./node_modules/core-js/modules/_library.js");
      var wksExt = __webpack_require__(/*! ./_wks-ext */"./node_modules/core-js/modules/_wks-ext.js");
      var defineProperty = __webpack_require__(/*! ./_object-dp */"./node_modules/core-js/modules/_object-dp.js").f;
      module.exports = function (name) {
        var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
        if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, {
          value: wksExt.f(name)
        });
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/_wks-ext.js": (
    /*!**************************************************!*\
      !*** ./node_modules/core-js/modules/_wks-ext.js ***!
      \**************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      exports.f = __webpack_require__(/*! ./_wks */"./node_modules/core-js/modules/_wks.js");

      /***/
    }),
    /***/"./node_modules/core-js/modules/_wks.js": (
    /*!**********************************************!*\
      !*** ./node_modules/core-js/modules/_wks.js ***!
      \**********************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      var store = __webpack_require__(/*! ./_shared */"./node_modules/core-js/modules/_shared.js")('wks');
      var uid = __webpack_require__(/*! ./_uid */"./node_modules/core-js/modules/_uid.js");
      var Symbol = __webpack_require__(/*! ./_global */"./node_modules/core-js/modules/_global.js").Symbol;
      var USE_SYMBOL = typeof Symbol == 'function';
      var $exports = module.exports = function (name) {
        return store[name] || (store[name] = USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
      };
      $exports.store = store;

      /***/
    }),
    /***/"./node_modules/core-js/modules/core.get-iterator-method.js": (
    /*!******************************************************************!*\
      !*** ./node_modules/core-js/modules/core.get-iterator-method.js ***!
      \******************************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      var classof = __webpack_require__(/*! ./_classof */"./node_modules/core-js/modules/_classof.js");
      var ITERATOR = __webpack_require__(/*! ./_wks */"./node_modules/core-js/modules/_wks.js")('iterator');
      var Iterators = __webpack_require__(/*! ./_iterators */"./node_modules/core-js/modules/_iterators.js");
      module.exports = __webpack_require__(/*! ./_core */"./node_modules/core-js/modules/_core.js").getIteratorMethod = function (it) {
        if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
      };

      /***/
    }),
    /***/"./node_modules/core-js/modules/es6.array.from.js": (
    /*!********************************************************!*\
      !*** ./node_modules/core-js/modules/es6.array.from.js ***!
      \********************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var ctx = __webpack_require__(/*! ./_ctx */"./node_modules/core-js/modules/_ctx.js");
      var $export = __webpack_require__(/*! ./_export */"./node_modules/core-js/modules/_export.js");
      var toObject = __webpack_require__(/*! ./_to-object */"./node_modules/core-js/modules/_to-object.js");
      var call = __webpack_require__(/*! ./_iter-call */"./node_modules/core-js/modules/_iter-call.js");
      var isArrayIter = __webpack_require__(/*! ./_is-array-iter */"./node_modules/core-js/modules/_is-array-iter.js");
      var toLength = __webpack_require__(/*! ./_to-length */"./node_modules/core-js/modules/_to-length.js");
      var createProperty = __webpack_require__(/*! ./_create-property */"./node_modules/core-js/modules/_create-property.js");
      var getIterFn = __webpack_require__(/*! ./core.get-iterator-method */"./node_modules/core-js/modules/core.get-iterator-method.js");
      $export($export.S + $export.F * !__webpack_require__(/*! ./_iter-detect */"./node_modules/core-js/modules/_iter-detect.js")(function (iter) {
        Array.from(iter);
      }), 'Array', {
        // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
        from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
          var O = toObject(arrayLike);
          var C = typeof this == 'function' ? this : Array;
          var aLen = arguments.length;
          var mapfn = aLen > 1 ? arguments[1] : undefined;
          var mapping = mapfn !== undefined;
          var index = 0;
          var iterFn = getIterFn(O);
          var length, result, step, iterator;
          if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
          // if object isn't iterable or it's array with default iterator - use simple case
          if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
            for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
              createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
            }
          } else {
            length = toLength(O.length);
            for (result = new C(length); length > index; index++) {
              createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
            }
          }
          result.length = index;
          return result;
        }
      });

      /***/
    }),
    /***/"./node_modules/core-js/modules/es6.array.iterator.js": (
    /*!************************************************************!*\
      !*** ./node_modules/core-js/modules/es6.array.iterator.js ***!
      \************************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var addToUnscopables = __webpack_require__(/*! ./_add-to-unscopables */"./node_modules/core-js/modules/_add-to-unscopables.js");
      var step = __webpack_require__(/*! ./_iter-step */"./node_modules/core-js/modules/_iter-step.js");
      var Iterators = __webpack_require__(/*! ./_iterators */"./node_modules/core-js/modules/_iterators.js");
      var toIObject = __webpack_require__(/*! ./_to-iobject */"./node_modules/core-js/modules/_to-iobject.js");

      // 22.1.3.4 Array.prototype.entries()
      // 22.1.3.13 Array.prototype.keys()
      // 22.1.3.29 Array.prototype.values()
      // 22.1.3.30 Array.prototype[@@iterator]()
      module.exports = __webpack_require__(/*! ./_iter-define */"./node_modules/core-js/modules/_iter-define.js")(Array, 'Array', function (iterated, kind) {
        this._t = toIObject(iterated); // target
        this._i = 0; // next index
        this._k = kind; // kind
        // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
      }, function () {
        var O = this._t;
        var kind = this._k;
        var index = this._i++;
        if (!O || index >= O.length) {
          this._t = undefined;
          return step(1);
        }
        if (kind == 'keys') return step(0, index);
        if (kind == 'values') return step(0, O[index]);
        return step(0, [index, O[index]]);
      }, 'values');

      // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
      Iterators.Arguments = Iterators.Array;
      addToUnscopables('keys');
      addToUnscopables('values');
      addToUnscopables('entries');

      /***/
    }),
    /***/"./node_modules/core-js/modules/es6.function.name.js": (
    /*!***********************************************************!*\
      !*** ./node_modules/core-js/modules/es6.function.name.js ***!
      \***********************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      var dP = __webpack_require__(/*! ./_object-dp */"./node_modules/core-js/modules/_object-dp.js").f;
      var FProto = Function.prototype;
      var nameRE = /^\s*function ([^ (]*)/;
      var NAME = 'name';

      // 19.2.4.2 name
      NAME in FProto || __webpack_require__(/*! ./_descriptors */"./node_modules/core-js/modules/_descriptors.js") && dP(FProto, NAME, {
        configurable: true,
        get: function () {
          try {
            return ('' + this).match(nameRE)[1];
          } catch (e) {
            return '';
          }
        }
      });

      /***/
    }),
    /***/"./node_modules/core-js/modules/es6.number.is-finite.js": (
    /*!**************************************************************!*\
      !*** ./node_modules/core-js/modules/es6.number.is-finite.js ***!
      \**************************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      // 20.1.2.2 Number.isFinite(number)
      var $export = __webpack_require__(/*! ./_export */"./node_modules/core-js/modules/_export.js");
      var _isFinite = __webpack_require__(/*! ./_global */"./node_modules/core-js/modules/_global.js").isFinite;
      $export($export.S, 'Number', {
        isFinite: function isFinite(it) {
          return typeof it == 'number' && _isFinite(it);
        }
      });

      /***/
    }),
    /***/"./node_modules/core-js/modules/es6.object.to-string.js": (
    /*!**************************************************************!*\
      !*** ./node_modules/core-js/modules/es6.object.to-string.js ***!
      \**************************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      // 19.1.3.6 Object.prototype.toString()
      var classof = __webpack_require__(/*! ./_classof */"./node_modules/core-js/modules/_classof.js");
      var test = {};
      test[__webpack_require__(/*! ./_wks */"./node_modules/core-js/modules/_wks.js")('toStringTag')] = 'z';
      if (test + '' != '[object z]') {
        __webpack_require__(/*! ./_redefine */"./node_modules/core-js/modules/_redefine.js")(Object.prototype, 'toString', function toString() {
          return '[object ' + classof(this) + ']';
        }, true);
      }

      /***/
    }),
    /***/"./node_modules/core-js/modules/es6.regexp.exec.js": (
    /*!*********************************************************!*\
      !*** ./node_modules/core-js/modules/es6.regexp.exec.js ***!
      \*********************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var regexpExec = __webpack_require__(/*! ./_regexp-exec */"./node_modules/core-js/modules/_regexp-exec.js");
      __webpack_require__(/*! ./_export */"./node_modules/core-js/modules/_export.js")({
        target: 'RegExp',
        proto: true,
        forced: regexpExec !== /./.exec
      }, {
        exec: regexpExec
      });

      /***/
    }),
    /***/"./node_modules/core-js/modules/es6.regexp.split.js": (
    /*!**********************************************************!*\
      !*** ./node_modules/core-js/modules/es6.regexp.split.js ***!
      \**********************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var isRegExp = __webpack_require__(/*! ./_is-regexp */"./node_modules/core-js/modules/_is-regexp.js");
      var anObject = __webpack_require__(/*! ./_an-object */"./node_modules/core-js/modules/_an-object.js");
      var speciesConstructor = __webpack_require__(/*! ./_species-constructor */"./node_modules/core-js/modules/_species-constructor.js");
      var advanceStringIndex = __webpack_require__(/*! ./_advance-string-index */"./node_modules/core-js/modules/_advance-string-index.js");
      var toLength = __webpack_require__(/*! ./_to-length */"./node_modules/core-js/modules/_to-length.js");
      var callRegExpExec = __webpack_require__(/*! ./_regexp-exec-abstract */"./node_modules/core-js/modules/_regexp-exec-abstract.js");
      var regexpExec = __webpack_require__(/*! ./_regexp-exec */"./node_modules/core-js/modules/_regexp-exec.js");
      var fails = __webpack_require__(/*! ./_fails */"./node_modules/core-js/modules/_fails.js");
      var $min = Math.min;
      var $push = [].push;
      var $SPLIT = 'split';
      var LENGTH = 'length';
      var LAST_INDEX = 'lastIndex';
      var MAX_UINT32 = 0xffffffff;

      // babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
      var SUPPORTS_Y = !fails(function () {
        RegExp(MAX_UINT32, 'y');
      });

      // @@split logic
      __webpack_require__(/*! ./_fix-re-wks */"./node_modules/core-js/modules/_fix-re-wks.js")('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
        var internalSplit;
        if ('abbc'[$SPLIT](/(b)*/)[1] == 'c' || 'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 || 'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 || '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 || '.'[$SPLIT](/()()/)[LENGTH] > 1 || ''[$SPLIT](/.?/)[LENGTH]) {
          // based on es5-shim implementation, need to rework it
          internalSplit = function (separator, limit) {
            var string = String(this);
            if (separator === undefined && limit === 0) return [];
            // If `separator` is not a regex, use native split
            if (!isRegExp(separator)) return $split.call(string, separator, limit);
            var output = [];
            var flags = (separator.ignoreCase ? 'i' : '') + (separator.multiline ? 'm' : '') + (separator.unicode ? 'u' : '') + (separator.sticky ? 'y' : '');
            var lastLastIndex = 0;
            var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
            // Make `global` and avoid `lastIndex` issues by working with a copy
            var separatorCopy = new RegExp(separator.source, flags + 'g');
            var match, lastIndex, lastLength;
            while (match = regexpExec.call(separatorCopy, string)) {
              lastIndex = separatorCopy[LAST_INDEX];
              if (lastIndex > lastLastIndex) {
                output.push(string.slice(lastLastIndex, match.index));
                if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
                lastLength = match[0][LENGTH];
                lastLastIndex = lastIndex;
                if (output[LENGTH] >= splitLimit) break;
              }
              if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
            }
            if (lastLastIndex === string[LENGTH]) {
              if (lastLength || !separatorCopy.test('')) output.push('');
            } else output.push(string.slice(lastLastIndex));
            return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
          };
          // Chakra, V8
        } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
          internalSplit = function (separator, limit) {
            return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
          };
        } else {
          internalSplit = $split;
        }
        return [
        // `String.prototype.split` method
        // https://tc39.github.io/ecma262/#sec-string.prototype.split
        function split(separator, limit) {
          var O = defined(this);
          var splitter = separator == undefined ? undefined : separator[SPLIT];
          return splitter !== undefined ? splitter.call(separator, O, limit) : internalSplit.call(String(O), separator, limit);
        },
        // `RegExp.prototype[@@split]` method
        // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
        //
        // NOTE: This cannot be properly polyfilled in engines that don't support
        // the 'y' flag.
        function (regexp, limit) {
          var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
          if (res.done) return res.value;
          var rx = anObject(regexp);
          var S = String(this);
          var C = speciesConstructor(rx, RegExp);
          var unicodeMatching = rx.unicode;
          var flags = (rx.ignoreCase ? 'i' : '') + (rx.multiline ? 'm' : '') + (rx.unicode ? 'u' : '') + (SUPPORTS_Y ? 'y' : 'g');

          // ^(? + rx + ) is needed, in combination with some S slicing, to
          // simulate the 'y' flag.
          var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
          var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
          if (lim === 0) return [];
          if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
          var p = 0;
          var q = 0;
          var A = [];
          while (q < S.length) {
            splitter.lastIndex = SUPPORTS_Y ? q : 0;
            var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
            var e;
            if (z === null || (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p) {
              q = advanceStringIndex(S, q, unicodeMatching);
            } else {
              A.push(S.slice(p, q));
              if (A.length === lim) return A;
              for (var i = 1; i <= z.length - 1; i++) {
                A.push(z[i]);
                if (A.length === lim) return A;
              }
              q = p = e;
            }
          }
          A.push(S.slice(p));
          return A;
        }];
      });

      /***/
    }),
    /***/"./node_modules/core-js/modules/es6.string.includes.js": (
    /*!*************************************************************!*\
      !*** ./node_modules/core-js/modules/es6.string.includes.js ***!
      \*************************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      // 21.1.3.7 String.prototype.includes(searchString, position = 0)
      var $export = __webpack_require__(/*! ./_export */"./node_modules/core-js/modules/_export.js");
      var context = __webpack_require__(/*! ./_string-context */"./node_modules/core-js/modules/_string-context.js");
      var INCLUDES = 'includes';
      $export($export.P + $export.F * __webpack_require__(/*! ./_fails-is-regexp */"./node_modules/core-js/modules/_fails-is-regexp.js")(INCLUDES), 'String', {
        includes: function includes(searchString /* , position = 0 */) {
          return !!~context(this, searchString, INCLUDES).indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
        }
      });

      /***/
    }),
    /***/"./node_modules/core-js/modules/es6.symbol.js": (
    /*!****************************************************!*\
      !*** ./node_modules/core-js/modules/es6.symbol.js ***!
      \****************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      // ECMAScript 6 symbols shim
      var global = __webpack_require__(/*! ./_global */"./node_modules/core-js/modules/_global.js");
      var has = __webpack_require__(/*! ./_has */"./node_modules/core-js/modules/_has.js");
      var DESCRIPTORS = __webpack_require__(/*! ./_descriptors */"./node_modules/core-js/modules/_descriptors.js");
      var $export = __webpack_require__(/*! ./_export */"./node_modules/core-js/modules/_export.js");
      var redefine = __webpack_require__(/*! ./_redefine */"./node_modules/core-js/modules/_redefine.js");
      var META = __webpack_require__(/*! ./_meta */"./node_modules/core-js/modules/_meta.js").KEY;
      var $fails = __webpack_require__(/*! ./_fails */"./node_modules/core-js/modules/_fails.js");
      var shared = __webpack_require__(/*! ./_shared */"./node_modules/core-js/modules/_shared.js");
      var setToStringTag = __webpack_require__(/*! ./_set-to-string-tag */"./node_modules/core-js/modules/_set-to-string-tag.js");
      var uid = __webpack_require__(/*! ./_uid */"./node_modules/core-js/modules/_uid.js");
      var wks = __webpack_require__(/*! ./_wks */"./node_modules/core-js/modules/_wks.js");
      var wksExt = __webpack_require__(/*! ./_wks-ext */"./node_modules/core-js/modules/_wks-ext.js");
      var wksDefine = __webpack_require__(/*! ./_wks-define */"./node_modules/core-js/modules/_wks-define.js");
      var enumKeys = __webpack_require__(/*! ./_enum-keys */"./node_modules/core-js/modules/_enum-keys.js");
      var isArray = __webpack_require__(/*! ./_is-array */"./node_modules/core-js/modules/_is-array.js");
      var anObject = __webpack_require__(/*! ./_an-object */"./node_modules/core-js/modules/_an-object.js");
      var isObject = __webpack_require__(/*! ./_is-object */"./node_modules/core-js/modules/_is-object.js");
      var toObject = __webpack_require__(/*! ./_to-object */"./node_modules/core-js/modules/_to-object.js");
      var toIObject = __webpack_require__(/*! ./_to-iobject */"./node_modules/core-js/modules/_to-iobject.js");
      var toPrimitive = __webpack_require__(/*! ./_to-primitive */"./node_modules/core-js/modules/_to-primitive.js");
      var createDesc = __webpack_require__(/*! ./_property-desc */"./node_modules/core-js/modules/_property-desc.js");
      var _create = __webpack_require__(/*! ./_object-create */"./node_modules/core-js/modules/_object-create.js");
      var gOPNExt = __webpack_require__(/*! ./_object-gopn-ext */"./node_modules/core-js/modules/_object-gopn-ext.js");
      var $GOPD = __webpack_require__(/*! ./_object-gopd */"./node_modules/core-js/modules/_object-gopd.js");
      var $GOPS = __webpack_require__(/*! ./_object-gops */"./node_modules/core-js/modules/_object-gops.js");
      var $DP = __webpack_require__(/*! ./_object-dp */"./node_modules/core-js/modules/_object-dp.js");
      var $keys = __webpack_require__(/*! ./_object-keys */"./node_modules/core-js/modules/_object-keys.js");
      var gOPD = $GOPD.f;
      var dP = $DP.f;
      var gOPN = gOPNExt.f;
      var $Symbol = global.Symbol;
      var $JSON = global.JSON;
      var _stringify = $JSON && $JSON.stringify;
      var PROTOTYPE = 'prototype';
      var HIDDEN = wks('_hidden');
      var TO_PRIMITIVE = wks('toPrimitive');
      var isEnum = {}.propertyIsEnumerable;
      var SymbolRegistry = shared('symbol-registry');
      var AllSymbols = shared('symbols');
      var OPSymbols = shared('op-symbols');
      var ObjectProto = Object[PROTOTYPE];
      var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
      var QObject = global.QObject;
      // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
      var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

      // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
      var setSymbolDesc = DESCRIPTORS && $fails(function () {
        return _create(dP({}, 'a', {
          get: function () {
            return dP(this, 'a', {
              value: 7
            }).a;
          }
        })).a != 7;
      }) ? function (it, key, D) {
        var protoDesc = gOPD(ObjectProto, key);
        if (protoDesc) delete ObjectProto[key];
        dP(it, key, D);
        if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
      } : dP;
      var wrap = function (tag) {
        var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
        sym._k = tag;
        return sym;
      };
      var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
        return typeof it == 'symbol';
      } : function (it) {
        return it instanceof $Symbol;
      };
      var $defineProperty = function defineProperty(it, key, D) {
        if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
        anObject(it);
        key = toPrimitive(key, true);
        anObject(D);
        if (has(AllSymbols, key)) {
          if (!D.enumerable) {
            if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
            it[HIDDEN][key] = true;
          } else {
            if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
            D = _create(D, {
              enumerable: createDesc(0, false)
            });
          }
          return setSymbolDesc(it, key, D);
        }
        return dP(it, key, D);
      };
      var $defineProperties = function defineProperties(it, P) {
        anObject(it);
        var keys = enumKeys(P = toIObject(P));
        var i = 0;
        var l = keys.length;
        var key;
        while (l > i) $defineProperty(it, key = keys[i++], P[key]);
        return it;
      };
      var $create = function create(it, P) {
        return P === undefined ? _create(it) : $defineProperties(_create(it), P);
      };
      var $propertyIsEnumerable = function propertyIsEnumerable(key) {
        var E = isEnum.call(this, key = toPrimitive(key, true));
        if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
        return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
      };
      var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
        it = toIObject(it);
        key = toPrimitive(key, true);
        if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
        var D = gOPD(it, key);
        if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
        return D;
      };
      var $getOwnPropertyNames = function getOwnPropertyNames(it) {
        var names = gOPN(toIObject(it));
        var result = [];
        var i = 0;
        var key;
        while (names.length > i) {
          if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
        }
        return result;
      };
      var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
        var IS_OP = it === ObjectProto;
        var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
        var result = [];
        var i = 0;
        var key;
        while (names.length > i) {
          if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
        }
        return result;
      };

      // 19.4.1.1 Symbol([description])
      if (!USE_NATIVE) {
        $Symbol = function Symbol() {
          if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
          var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
          var $set = function (value) {
            if (this === ObjectProto) $set.call(OPSymbols, value);
            if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
            setSymbolDesc(this, tag, createDesc(1, value));
          };
          if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, {
            configurable: true,
            set: $set
          });
          return wrap(tag);
        };
        redefine($Symbol[PROTOTYPE], 'toString', function toString() {
          return this._k;
        });
        $GOPD.f = $getOwnPropertyDescriptor;
        $DP.f = $defineProperty;
        __webpack_require__(/*! ./_object-gopn */"./node_modules/core-js/modules/_object-gopn.js").f = gOPNExt.f = $getOwnPropertyNames;
        __webpack_require__(/*! ./_object-pie */"./node_modules/core-js/modules/_object-pie.js").f = $propertyIsEnumerable;
        $GOPS.f = $getOwnPropertySymbols;
        if (DESCRIPTORS && !__webpack_require__(/*! ./_library */"./node_modules/core-js/modules/_library.js")) {
          redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
        }
        wksExt.f = function (name) {
          return wrap(wks(name));
        };
      }
      $export($export.G + $export.W + $export.F * !USE_NATIVE, {
        Symbol: $Symbol
      });
      for (var es6Symbols =
        // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
        'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j = 0; es6Symbols.length > j;) wks(es6Symbols[j++]);
      for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
      $export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
        // 19.4.2.1 Symbol.for(key)
        'for': function (key) {
          return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
        },
        // 19.4.2.5 Symbol.keyFor(sym)
        keyFor: function keyFor(sym) {
          if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
          for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
        },
        useSetter: function () {
          setter = true;
        },
        useSimple: function () {
          setter = false;
        }
      });
      $export($export.S + $export.F * !USE_NATIVE, 'Object', {
        // 19.1.2.2 Object.create(O [, Properties])
        create: $create,
        // 19.1.2.4 Object.defineProperty(O, P, Attributes)
        defineProperty: $defineProperty,
        // 19.1.2.3 Object.defineProperties(O, Properties)
        defineProperties: $defineProperties,
        // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
        getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
        // 19.1.2.7 Object.getOwnPropertyNames(O)
        getOwnPropertyNames: $getOwnPropertyNames,
        // 19.1.2.8 Object.getOwnPropertySymbols(O)
        getOwnPropertySymbols: $getOwnPropertySymbols
      });

      // Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
      // https://bugs.chromium.org/p/v8/issues/detail?id=3443
      var FAILS_ON_PRIMITIVES = $fails(function () {
        $GOPS.f(1);
      });
      $export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
        getOwnPropertySymbols: function getOwnPropertySymbols(it) {
          return $GOPS.f(toObject(it));
        }
      });

      // 24.3.2 JSON.stringify(value [, replacer [, space]])
      $JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
        var S = $Symbol();
        // MS Edge converts symbol values to JSON as {}
        // WebKit converts symbol values to JSON as null
        // V8 throws on boxed symbols
        return _stringify([S]) != '[null]' || _stringify({
          a: S
        }) != '{}' || _stringify(Object(S)) != '{}';
      })), 'JSON', {
        stringify: function stringify(it) {
          var args = [it];
          var i = 1;
          var replacer, $replacer;
          while (arguments.length > i) args.push(arguments[i++]);
          $replacer = replacer = args[1];
          if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
          if (!isArray(replacer)) replacer = function (key, value) {
            if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
            if (!isSymbol(value)) return value;
          };
          args[1] = replacer;
          return _stringify.apply($JSON, args);
        }
      });

      // 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
      $Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(/*! ./_hide */"./node_modules/core-js/modules/_hide.js")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
      // 19.4.3.5 Symbol.prototype[@@toStringTag]
      setToStringTag($Symbol, 'Symbol');
      // 20.2.1.9 Math[@@toStringTag]
      setToStringTag(Math, 'Math', true);
      // 24.3.3 JSON[@@toStringTag]
      setToStringTag(global.JSON, 'JSON', true);

      /***/
    }),
    /***/"./node_modules/core-js/modules/es7.array.includes.js": (
    /*!************************************************************!*\
      !*** ./node_modules/core-js/modules/es7.array.includes.js ***!
      \************************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      // https://github.com/tc39/Array.prototype.includes
      var $export = __webpack_require__(/*! ./_export */"./node_modules/core-js/modules/_export.js");
      var $includes = __webpack_require__(/*! ./_array-includes */"./node_modules/core-js/modules/_array-includes.js")(true);
      $export($export.P, 'Array', {
        includes: function includes(el /* , fromIndex = 0 */) {
          return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
        }
      });
      __webpack_require__(/*! ./_add-to-unscopables */"./node_modules/core-js/modules/_add-to-unscopables.js")('includes');

      /***/
    }),
    /***/"./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js": (
    /*!*********************************************************************************!*\
      !*** ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js ***!
      \*********************************************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      // https://github.com/tc39/proposal-object-getownpropertydescriptors
      var $export = __webpack_require__(/*! ./_export */"./node_modules/core-js/modules/_export.js");
      var ownKeys = __webpack_require__(/*! ./_own-keys */"./node_modules/core-js/modules/_own-keys.js");
      var toIObject = __webpack_require__(/*! ./_to-iobject */"./node_modules/core-js/modules/_to-iobject.js");
      var gOPD = __webpack_require__(/*! ./_object-gopd */"./node_modules/core-js/modules/_object-gopd.js");
      var createProperty = __webpack_require__(/*! ./_create-property */"./node_modules/core-js/modules/_create-property.js");
      $export($export.S, 'Object', {
        getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
          var O = toIObject(object);
          var getDesc = gOPD.f;
          var keys = ownKeys(O);
          var result = {};
          var i = 0;
          var key, desc;
          while (keys.length > i) {
            desc = getDesc(O, key = keys[i++]);
            if (desc !== undefined) createProperty(result, key, desc);
          }
          return result;
        }
      });

      /***/
    }),
    /***/"./node_modules/core-js/modules/es7.symbol.async-iterator.js": (
    /*!*******************************************************************!*\
      !*** ./node_modules/core-js/modules/es7.symbol.async-iterator.js ***!
      \*******************************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      __webpack_require__(/*! ./_wks-define */"./node_modules/core-js/modules/_wks-define.js")('asyncIterator');

      /***/
    }),
    /***/"./node_modules/core-js/modules/web.dom.iterable.js": (
    /*!**********************************************************!*\
      !*** ./node_modules/core-js/modules/web.dom.iterable.js ***!
      \**********************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      var $iterators = __webpack_require__(/*! ./es6.array.iterator */"./node_modules/core-js/modules/es6.array.iterator.js");
      var getKeys = __webpack_require__(/*! ./_object-keys */"./node_modules/core-js/modules/_object-keys.js");
      var redefine = __webpack_require__(/*! ./_redefine */"./node_modules/core-js/modules/_redefine.js");
      var global = __webpack_require__(/*! ./_global */"./node_modules/core-js/modules/_global.js");
      var hide = __webpack_require__(/*! ./_hide */"./node_modules/core-js/modules/_hide.js");
      var Iterators = __webpack_require__(/*! ./_iterators */"./node_modules/core-js/modules/_iterators.js");
      var wks = __webpack_require__(/*! ./_wks */"./node_modules/core-js/modules/_wks.js");
      var ITERATOR = wks('iterator');
      var TO_STRING_TAG = wks('toStringTag');
      var ArrayValues = Iterators.Array;
      var DOMIterables = {
        CSSRuleList: true,
        // TODO: Not spec compliant, should be false.
        CSSStyleDeclaration: false,
        CSSValueList: false,
        ClientRectList: false,
        DOMRectList: false,
        DOMStringList: false,
        DOMTokenList: true,
        DataTransferItemList: false,
        FileList: false,
        HTMLAllCollection: false,
        HTMLCollection: false,
        HTMLFormElement: false,
        HTMLSelectElement: false,
        MediaList: true,
        // TODO: Not spec compliant, should be false.
        MimeTypeArray: false,
        NamedNodeMap: false,
        NodeList: true,
        PaintRequestList: false,
        Plugin: false,
        PluginArray: false,
        SVGLengthList: false,
        SVGNumberList: false,
        SVGPathSegList: false,
        SVGPointList: false,
        SVGStringList: false,
        SVGTransformList: false,
        SourceBufferList: false,
        StyleSheetList: true,
        // TODO: Not spec compliant, should be false.
        TextTrackCueList: false,
        TextTrackList: false,
        TouchList: false
      };
      for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
        var NAME = collections[i];
        var explicit = DOMIterables[NAME];
        var Collection = global[NAME];
        var proto = Collection && Collection.prototype;
        var key;
        if (proto) {
          if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
          if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
          Iterators[NAME] = ArrayValues;
          if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
        }
      }

      /***/
    }),
    /***/"./node_modules/crypt/crypt.js": (
    /*!*************************************!*\
      !*** ./node_modules/crypt/crypt.js ***!
      \*************************************/
    /*! no static exports found */
    /***/
    function (module, exports) {
      (function () {
        var base64map = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
          crypt = {
            // Bit-wise rotation left
            rotl: function (n, b) {
              return n << b | n >>> 32 - b;
            },
            // Bit-wise rotation right
            rotr: function (n, b) {
              return n << 32 - b | n >>> b;
            },
            // Swap big-endian to little-endian and vice versa
            endian: function (n) {
              // If number given, swap endian
              if (n.constructor == Number) {
                return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
              }

              // Else, assume array and swap all items
              for (var i = 0; i < n.length; i++) n[i] = crypt.endian(n[i]);
              return n;
            },
            // Generate an array of any length of random bytes
            randomBytes: function (n) {
              for (var bytes = []; n > 0; n--) bytes.push(Math.floor(Math.random() * 256));
              return bytes;
            },
            // Convert a byte array to big-endian 32-bit words
            bytesToWords: function (bytes) {
              for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8) words[b >>> 5] |= bytes[i] << 24 - b % 32;
              return words;
            },
            // Convert big-endian 32-bit words to a byte array
            wordsToBytes: function (words) {
              for (var bytes = [], b = 0; b < words.length * 32; b += 8) bytes.push(words[b >>> 5] >>> 24 - b % 32 & 0xFF);
              return bytes;
            },
            // Convert a byte array to a hex string
            bytesToHex: function (bytes) {
              for (var hex = [], i = 0; i < bytes.length; i++) {
                hex.push((bytes[i] >>> 4).toString(16));
                hex.push((bytes[i] & 0xF).toString(16));
              }
              return hex.join('');
            },
            // Convert a hex string to a byte array
            hexToBytes: function (hex) {
              for (var bytes = [], c = 0; c < hex.length; c += 2) bytes.push(parseInt(hex.substr(c, 2), 16));
              return bytes;
            },
            // Convert a byte array to a base-64 string
            bytesToBase64: function (bytes) {
              for (var base64 = [], i = 0; i < bytes.length; i += 3) {
                var triplet = bytes[i] << 16 | bytes[i + 1] << 8 | bytes[i + 2];
                for (var j = 0; j < 4; j++) if (i * 8 + j * 6 <= bytes.length * 8) base64.push(base64map.charAt(triplet >>> 6 * (3 - j) & 0x3F));else base64.push('=');
              }
              return base64.join('');
            },
            // Convert a base-64 string to a byte array
            base64ToBytes: function (base64) {
              // Remove non-base-64 characters
              base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');
              for (var bytes = [], i = 0, imod4 = 0; i < base64.length; imod4 = ++i % 4) {
                if (imod4 == 0) continue;
                bytes.push((base64map.indexOf(base64.charAt(i - 1)) & Math.pow(2, -2 * imod4 + 8) - 1) << imod4 * 2 | base64map.indexOf(base64.charAt(i)) >>> 6 - imod4 * 2);
              }
              return bytes;
            }
          };
        module.exports = crypt;
      })();

      /***/
    }),
    /***/"./node_modules/is-buffer/index.js": (
    /*!*****************************************!*\
      !*** ./node_modules/is-buffer/index.js ***!
      \*****************************************/
    /*! no static exports found */
    /***/
    function (module, exports) {
      /*!
       * Determine if an object is a Buffer
       *
       * @author   Feross Aboukhadijeh <https://feross.org>
       * @license  MIT
       */

      // The _isBuffer check is for Safari 5-7 support, because it's missing
      // Object.prototype.constructor. Remove this eventually
      module.exports = function (obj) {
        return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer);
      };
      function isBuffer(obj) {
        return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
      }

      // For Node v0.10 support. Remove this eventually.
      function isSlowBuffer(obj) {
        return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0));
      }

      /***/
    }),
    /***/"./node_modules/md5/md5.js": (
    /*!*********************************!*\
      !*** ./node_modules/md5/md5.js ***!
      \*********************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      (function () {
        var crypt = __webpack_require__(/*! crypt */"./node_modules/crypt/crypt.js"),
          utf8 = __webpack_require__(/*! charenc */"./node_modules/charenc/charenc.js").utf8,
          isBuffer = __webpack_require__(/*! is-buffer */"./node_modules/is-buffer/index.js"),
          bin = __webpack_require__(/*! charenc */"./node_modules/charenc/charenc.js").bin,
          // The core
          md5 = function (message, options) {
            // Convert to byte array
            if (message.constructor == String) {
              if (options && options.encoding === 'binary') message = bin.stringToBytes(message);else message = utf8.stringToBytes(message);
            } else if (isBuffer(message)) message = Array.prototype.slice.call(message, 0);else if (!Array.isArray(message) && message.constructor !== Uint8Array) message = message.toString();
            // else, assume byte array already

            var m = crypt.bytesToWords(message),
              l = message.length * 8,
              a = 1732584193,
              b = -271733879,
              c = -1732584194,
              d = 271733878;

            // Swap endian
            for (var i = 0; i < m.length; i++) {
              m[i] = (m[i] << 8 | m[i] >>> 24) & 0x00FF00FF | (m[i] << 24 | m[i] >>> 8) & 0xFF00FF00;
            }

            // Padding
            m[l >>> 5] |= 0x80 << l % 32;
            m[(l + 64 >>> 9 << 4) + 14] = l;

            // Method shortcuts
            var FF = md5._ff,
              GG = md5._gg,
              HH = md5._hh,
              II = md5._ii;
            for (var i = 0; i < m.length; i += 16) {
              var aa = a,
                bb = b,
                cc = c,
                dd = d;
              a = FF(a, b, c, d, m[i + 0], 7, -680876936);
              d = FF(d, a, b, c, m[i + 1], 12, -389564586);
              c = FF(c, d, a, b, m[i + 2], 17, 606105819);
              b = FF(b, c, d, a, m[i + 3], 22, -1044525330);
              a = FF(a, b, c, d, m[i + 4], 7, -176418897);
              d = FF(d, a, b, c, m[i + 5], 12, 1200080426);
              c = FF(c, d, a, b, m[i + 6], 17, -1473231341);
              b = FF(b, c, d, a, m[i + 7], 22, -45705983);
              a = FF(a, b, c, d, m[i + 8], 7, 1770035416);
              d = FF(d, a, b, c, m[i + 9], 12, -1958414417);
              c = FF(c, d, a, b, m[i + 10], 17, -42063);
              b = FF(b, c, d, a, m[i + 11], 22, -1990404162);
              a = FF(a, b, c, d, m[i + 12], 7, 1804603682);
              d = FF(d, a, b, c, m[i + 13], 12, -40341101);
              c = FF(c, d, a, b, m[i + 14], 17, -1502002290);
              b = FF(b, c, d, a, m[i + 15], 22, 1236535329);
              a = GG(a, b, c, d, m[i + 1], 5, -165796510);
              d = GG(d, a, b, c, m[i + 6], 9, -1069501632);
              c = GG(c, d, a, b, m[i + 11], 14, 643717713);
              b = GG(b, c, d, a, m[i + 0], 20, -373897302);
              a = GG(a, b, c, d, m[i + 5], 5, -701558691);
              d = GG(d, a, b, c, m[i + 10], 9, 38016083);
              c = GG(c, d, a, b, m[i + 15], 14, -660478335);
              b = GG(b, c, d, a, m[i + 4], 20, -405537848);
              a = GG(a, b, c, d, m[i + 9], 5, 568446438);
              d = GG(d, a, b, c, m[i + 14], 9, -1019803690);
              c = GG(c, d, a, b, m[i + 3], 14, -187363961);
              b = GG(b, c, d, a, m[i + 8], 20, 1163531501);
              a = GG(a, b, c, d, m[i + 13], 5, -1444681467);
              d = GG(d, a, b, c, m[i + 2], 9, -51403784);
              c = GG(c, d, a, b, m[i + 7], 14, 1735328473);
              b = GG(b, c, d, a, m[i + 12], 20, -1926607734);
              a = HH(a, b, c, d, m[i + 5], 4, -378558);
              d = HH(d, a, b, c, m[i + 8], 11, -2022574463);
              c = HH(c, d, a, b, m[i + 11], 16, 1839030562);
              b = HH(b, c, d, a, m[i + 14], 23, -35309556);
              a = HH(a, b, c, d, m[i + 1], 4, -1530992060);
              d = HH(d, a, b, c, m[i + 4], 11, 1272893353);
              c = HH(c, d, a, b, m[i + 7], 16, -155497632);
              b = HH(b, c, d, a, m[i + 10], 23, -1094730640);
              a = HH(a, b, c, d, m[i + 13], 4, 681279174);
              d = HH(d, a, b, c, m[i + 0], 11, -358537222);
              c = HH(c, d, a, b, m[i + 3], 16, -722521979);
              b = HH(b, c, d, a, m[i + 6], 23, 76029189);
              a = HH(a, b, c, d, m[i + 9], 4, -640364487);
              d = HH(d, a, b, c, m[i + 12], 11, -421815835);
              c = HH(c, d, a, b, m[i + 15], 16, 530742520);
              b = HH(b, c, d, a, m[i + 2], 23, -995338651);
              a = II(a, b, c, d, m[i + 0], 6, -198630844);
              d = II(d, a, b, c, m[i + 7], 10, 1126891415);
              c = II(c, d, a, b, m[i + 14], 15, -1416354905);
              b = II(b, c, d, a, m[i + 5], 21, -57434055);
              a = II(a, b, c, d, m[i + 12], 6, 1700485571);
              d = II(d, a, b, c, m[i + 3], 10, -1894986606);
              c = II(c, d, a, b, m[i + 10], 15, -1051523);
              b = II(b, c, d, a, m[i + 1], 21, -2054922799);
              a = II(a, b, c, d, m[i + 8], 6, 1873313359);
              d = II(d, a, b, c, m[i + 15], 10, -30611744);
              c = II(c, d, a, b, m[i + 6], 15, -1560198380);
              b = II(b, c, d, a, m[i + 13], 21, 1309151649);
              a = II(a, b, c, d, m[i + 4], 6, -145523070);
              d = II(d, a, b, c, m[i + 11], 10, -1120210379);
              c = II(c, d, a, b, m[i + 2], 15, 718787259);
              b = II(b, c, d, a, m[i + 9], 21, -343485551);
              a = a + aa >>> 0;
              b = b + bb >>> 0;
              c = c + cc >>> 0;
              d = d + dd >>> 0;
            }
            return crypt.endian([a, b, c, d]);
          };

        // Auxiliary functions
        md5._ff = function (a, b, c, d, x, s, t) {
          var n = a + (b & c | ~b & d) + (x >>> 0) + t;
          return (n << s | n >>> 32 - s) + b;
        };
        md5._gg = function (a, b, c, d, x, s, t) {
          var n = a + (b & d | c & ~d) + (x >>> 0) + t;
          return (n << s | n >>> 32 - s) + b;
        };
        md5._hh = function (a, b, c, d, x, s, t) {
          var n = a + (b ^ c ^ d) + (x >>> 0) + t;
          return (n << s | n >>> 32 - s) + b;
        };
        md5._ii = function (a, b, c, d, x, s, t) {
          var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
          return (n << s | n >>> 32 - s) + b;
        };

        // Package private blocksize
        md5._blocksize = 16;
        md5._digestsize = 16;
        module.exports = function (message, options) {
          if (message === undefined || message === null) throw new Error('Illegal argument ' + message);
          var digestbytes = crypt.wordsToBytes(md5(message, options));
          return options && options.asBytes ? digestbytes : options && options.asString ? bin.bytesToString(digestbytes) : crypt.bytesToHex(digestbytes);
        };
      })();

      /***/
    }),
    /***/"./node_modules/regenerator-runtime/runtime.js": (
    /*!*****************************************************!*\
      !*** ./node_modules/regenerator-runtime/runtime.js ***!
      \*****************************************************/
    /*! no static exports found */
    /***/
    function (module, exports, __webpack_require__) {
      /**
       * Copyright (c) 2014-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */

      var runtime = function (exports) {
        "use strict";

        var Op = Object.prototype;
        var hasOwn = Op.hasOwnProperty;
        var undefined; // More compressible than void 0.
        var $Symbol = typeof Symbol === "function" ? Symbol : {};
        var iteratorSymbol = $Symbol.iterator || "@@iterator";
        var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
        var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
        function define(obj, key, value) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          });
          return obj[key];
        }
        try {
          // IE 8 has a broken Object.defineProperty that only works on DOM objects.
          define({}, "");
        } catch (err) {
          define = function (obj, key, value) {
            return obj[key] = value;
          };
        }
        function wrap(innerFn, outerFn, self, tryLocsList) {
          // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
          var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
          var generator = Object.create(protoGenerator.prototype);
          var context = new Context(tryLocsList || []);

          // The ._invoke method unifies the implementations of the .next,
          // .throw, and .return methods.
          generator._invoke = makeInvokeMethod(innerFn, self, context);
          return generator;
        }
        exports.wrap = wrap;

        // Try/catch helper to minimize deoptimizations. Returns a completion
        // record like context.tryEntries[i].completion. This interface could
        // have been (and was previously) designed to take a closure to be
        // invoked without arguments, but in all the cases we care about we
        // already have an existing method we want to call, so there's no need
        // to create a new function object. We can even get away with assuming
        // the method takes exactly one argument, since that happens to be true
        // in every case, so we don't have to touch the arguments object. The
        // only additional allocation required is the completion record, which
        // has a stable shape and so hopefully should be cheap to allocate.
        function tryCatch(fn, obj, arg) {
          try {
            return {
              type: "normal",
              arg: fn.call(obj, arg)
            };
          } catch (err) {
            return {
              type: "throw",
              arg: err
            };
          }
        }
        var GenStateSuspendedStart = "suspendedStart";
        var GenStateSuspendedYield = "suspendedYield";
        var GenStateExecuting = "executing";
        var GenStateCompleted = "completed";

        // Returning this object from the innerFn has the same effect as
        // breaking out of the dispatch switch statement.
        var ContinueSentinel = {};

        // Dummy constructor functions that we use as the .constructor and
        // .constructor.prototype properties for functions that return Generator
        // objects. For full spec compliance, you may wish to configure your
        // minifier not to mangle the names of these two functions.
        function Generator() {}
        function GeneratorFunction() {}
        function GeneratorFunctionPrototype() {}

        // This is a polyfill for %IteratorPrototype% for environments that
        // don't natively support it.
        var IteratorPrototype = {};
        IteratorPrototype[iteratorSymbol] = function () {
          return this;
        };
        var getProto = Object.getPrototypeOf;
        var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
        if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
          // This environment has a native %IteratorPrototype%; use it instead
          // of the polyfill.
          IteratorPrototype = NativeIteratorPrototype;
        }
        var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
        GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
        GeneratorFunctionPrototype.constructor = GeneratorFunction;
        GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");

        // Helper for defining the .next, .throw, and .return methods of the
        // Iterator interface in terms of a single ._invoke method.
        function defineIteratorMethods(prototype) {
          ["next", "throw", "return"].forEach(function (method) {
            define(prototype, method, function (arg) {
              return this._invoke(method, arg);
            });
          });
        }
        exports.isGeneratorFunction = function (genFun) {
          var ctor = typeof genFun === "function" && genFun.constructor;
          return ctor ? ctor === GeneratorFunction ||
          // For the native GeneratorFunction constructor, the best we can
          // do is to check its .name property.
          (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
        };
        exports.mark = function (genFun) {
          if (Object.setPrototypeOf) {
            Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
          } else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
          }
          genFun.prototype = Object.create(Gp);
          return genFun;
        };

        // Within the body of any async function, `await x` is transformed to
        // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
        // `hasOwn.call(value, "__await")` to determine if the yielded value is
        // meant to be awaited.
        exports.awrap = function (arg) {
          return {
            __await: arg
          };
        };
        function AsyncIterator(generator, PromiseImpl) {
          function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") {
              reject(record.arg);
            } else {
              var result = record.arg;
              var value = result.value;
              if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
                return PromiseImpl.resolve(value.__await).then(function (value) {
                  invoke("next", value, resolve, reject);
                }, function (err) {
                  invoke("throw", err, resolve, reject);
                });
              }
              return PromiseImpl.resolve(value).then(function (unwrapped) {
                // When a yielded Promise is resolved, its final value becomes
                // the .value of the Promise<{value,done}> result for the
                // current iteration.
                result.value = unwrapped;
                resolve(result);
              }, function (error) {
                // If a rejected Promise was yielded, throw the rejection back
                // into the async generator function so it can be handled there.
                return invoke("throw", error, resolve, reject);
              });
            }
          }
          var previousPromise;
          function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
              return new PromiseImpl(function (resolve, reject) {
                invoke(method, arg, resolve, reject);
              });
            }
            return previousPromise =
            // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
            // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
          }

          // Define the unified helper method that is used to implement .next,
          // .throw, and .return (see defineIteratorMethods).
          this._invoke = enqueue;
        }
        defineIteratorMethods(AsyncIterator.prototype);
        AsyncIterator.prototype[asyncIteratorSymbol] = function () {
          return this;
        };
        exports.AsyncIterator = AsyncIterator;

        // Note that simple async functions are implemented on top of
        // AsyncIterator objects; they just return a Promise for the value of
        // the final result produced by the iterator.
        exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
          if (PromiseImpl === void 0) PromiseImpl = Promise;
          var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
          return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
          : iter.next().then(function (result) {
            return result.done ? result.value : iter.next();
          });
        };
        function makeInvokeMethod(innerFn, self, context) {
          var state = GenStateSuspendedStart;
          return function invoke(method, arg) {
            if (state === GenStateExecuting) {
              throw new Error("Generator is already running");
            }
            if (state === GenStateCompleted) {
              if (method === "throw") {
                throw arg;
              }

              // Be forgiving, per 25.3.3.3.3 of the spec:
              // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
              return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while (true) {
              var delegate = context.delegate;
              if (delegate) {
                var delegateResult = maybeInvokeDelegate(delegate, context);
                if (delegateResult) {
                  if (delegateResult === ContinueSentinel) continue;
                  return delegateResult;
                }
              }
              if (context.method === "next") {
                // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
              } else if (context.method === "throw") {
                if (state === GenStateSuspendedStart) {
                  state = GenStateCompleted;
                  throw context.arg;
                }
                context.dispatchException(context.arg);
              } else if (context.method === "return") {
                context.abrupt("return", context.arg);
              }
              state = GenStateExecuting;
              var record = tryCatch(innerFn, self, context);
              if (record.type === "normal") {
                // If an exception is thrown from innerFn, we leave state ===
                // GenStateExecuting and loop back for another invocation.
                state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                if (record.arg === ContinueSentinel) {
                  continue;
                }
                return {
                  value: record.arg,
                  done: context.done
                };
              } else if (record.type === "throw") {
                state = GenStateCompleted;
                // Dispatch the exception by looping back around to the
                // context.dispatchException(context.arg) call above.
                context.method = "throw";
                context.arg = record.arg;
              }
            }
          };
        }

        // Call delegate.iterator[context.method](context.arg) and handle the
        // result, either by returning a { value, done } result from the
        // delegate iterator, or by modifying context.method and context.arg,
        // setting context.delegate to null, and returning the ContinueSentinel.
        function maybeInvokeDelegate(delegate, context) {
          var method = delegate.iterator[context.method];
          if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method always terminates the yield* loop.
            context.delegate = null;
            if (context.method === "throw") {
              // Note: ["return"] must be used for ES3 parsing compatibility.
              if (delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") {
                  // If maybeInvokeDelegate(context) changed context.method from
                  // "return" to "throw", let that override the TypeError below.
                  return ContinueSentinel;
                }
              }
              context.method = "throw";
              context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
          }
          var record = tryCatch(method, delegate.iterator, context.arg);
          if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
          }
          var info = record.arg;
          if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
          }
          if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;

            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;

            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
              context.method = "next";
              context.arg = undefined;
            }
          } else {
            // Re-yield the result returned by the delegate method.
            return info;
          }

          // The delegate iterator is finished, so forget it and continue with
          // the outer generator.
          context.delegate = null;
          return ContinueSentinel;
        }

        // Define Generator.prototype.{next,throw,return} in terms of the
        // unified ._invoke helper method.
        defineIteratorMethods(Gp);
        define(Gp, toStringTagSymbol, "Generator");

        // A Generator should always return itself as the iterator object when the
        // @@iterator function is called on it. Some browsers' implementations of the
        // iterator prototype chain incorrectly implement this, causing the Generator
        // object to not be returned from this call. This ensures that doesn't happen.
        // See https://github.com/facebook/regenerator/issues/274 for more details.
        Gp[iteratorSymbol] = function () {
          return this;
        };
        Gp.toString = function () {
          return "[object Generator]";
        };
        function pushTryEntry(locs) {
          var entry = {
            tryLoc: locs[0]
          };
          if (1 in locs) {
            entry.catchLoc = locs[1];
          }
          if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
          }
          this.tryEntries.push(entry);
        }
        function resetTryEntry(entry) {
          var record = entry.completion || {};
          record.type = "normal";
          delete record.arg;
          entry.completion = record;
        }
        function Context(tryLocsList) {
          // The root entry object (effectively a try statement without a catch
          // or a finally block) gives us a place to store values thrown from
          // locations where there is no enclosing try statement.
          this.tryEntries = [{
            tryLoc: "root"
          }];
          tryLocsList.forEach(pushTryEntry, this);
          this.reset(true);
        }
        exports.keys = function (object) {
          var keys = [];
          for (var key in object) {
            keys.push(key);
          }
          keys.reverse();

          // Rather than returning an object with a next method, we keep
          // things simple and return the next function itself.
          return function next() {
            while (keys.length) {
              var key = keys.pop();
              if (key in object) {
                next.value = key;
                next.done = false;
                return next;
              }
            }

            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
          };
        };
        function values(iterable) {
          if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) {
              return iteratorMethod.call(iterable);
            }
            if (typeof iterable.next === "function") {
              return iterable;
            }
            if (!isNaN(iterable.length)) {
              var i = -1,
                next = function next() {
                  while (++i < iterable.length) {
                    if (hasOwn.call(iterable, i)) {
                      next.value = iterable[i];
                      next.done = false;
                      return next;
                    }
                  }
                  next.value = undefined;
                  next.done = true;
                  return next;
                };
              return next.next = next;
            }
          }

          // Return an iterator with no values.
          return {
            next: doneResult
          };
        }
        exports.values = values;
        function doneResult() {
          return {
            value: undefined,
            done: true
          };
        }
        Context.prototype = {
          constructor: Context,
          reset: function (skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
              for (var name in this) {
                // Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
                  this[name] = undefined;
                }
              }
            }
          },
          stop: function () {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") {
              throw rootRecord.arg;
            }
            return this.rval;
          },
          dispatchException: function (exception) {
            if (this.done) {
              throw exception;
            }
            var context = this;
            function handle(loc, caught) {
              record.type = "throw";
              record.arg = exception;
              context.next = loc;
              if (caught) {
                // If the dispatched exception was caught by a catch block,
                // then let that catch block handle the exception normally.
                context.method = "next";
                context.arg = undefined;
              }
              return !!caught;
            }
            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var entry = this.tryEntries[i];
              var record = entry.completion;
              if (entry.tryLoc === "root") {
                // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
              }
              if (entry.tryLoc <= this.prev) {
                var hasCatch = hasOwn.call(entry, "catchLoc");
                var hasFinally = hasOwn.call(entry, "finallyLoc");
                if (hasCatch && hasFinally) {
                  if (this.prev < entry.catchLoc) {
                    return handle(entry.catchLoc, true);
                  } else if (this.prev < entry.finallyLoc) {
                    return handle(entry.finallyLoc);
                  }
                } else if (hasCatch) {
                  if (this.prev < entry.catchLoc) {
                    return handle(entry.catchLoc, true);
                  }
                } else if (hasFinally) {
                  if (this.prev < entry.finallyLoc) {
                    return handle(entry.finallyLoc);
                  }
                } else {
                  throw new Error("try statement without catch or finally");
                }
              }
            }
          },
          abrupt: function (type, arg) {
            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var entry = this.tryEntries[i];
              if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                var finallyEntry = entry;
                break;
              }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
              // Ignore the finally entry if control is not jumping to a
              // location outside the try/catch block.
              finallyEntry = null;
            }
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
              this.method = "next";
              this.next = finallyEntry.finallyLoc;
              return ContinueSentinel;
            }
            return this.complete(record);
          },
          complete: function (record, afterLoc) {
            if (record.type === "throw") {
              throw record.arg;
            }
            if (record.type === "break" || record.type === "continue") {
              this.next = record.arg;
            } else if (record.type === "return") {
              this.rval = this.arg = record.arg;
              this.method = "return";
              this.next = "end";
            } else if (record.type === "normal" && afterLoc) {
              this.next = afterLoc;
            }
            return ContinueSentinel;
          },
          finish: function (finallyLoc) {
            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var entry = this.tryEntries[i];
              if (entry.finallyLoc === finallyLoc) {
                this.complete(entry.completion, entry.afterLoc);
                resetTryEntry(entry);
                return ContinueSentinel;
              }
            }
          },
          "catch": function (tryLoc) {
            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var entry = this.tryEntries[i];
              if (entry.tryLoc === tryLoc) {
                var record = entry.completion;
                if (record.type === "throw") {
                  var thrown = record.arg;
                  resetTryEntry(entry);
                }
                return thrown;
              }
            }

            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
          },
          delegateYield: function (iterable, resultName, nextLoc) {
            this.delegate = {
              iterator: values(iterable),
              resultName: resultName,
              nextLoc: nextLoc
            };
            if (this.method === "next") {
              // Deliberately forget the last sent value so that we don't
              // accidentally pass it on to the delegate.
              this.arg = undefined;
            }
            return ContinueSentinel;
          }
        };

        // Regardless of whether this script is executing as a CommonJS module
        // or not, return the runtime object so that we can declare the variable
        // regeneratorRuntime in the outer scope, which allows this module to be
        // injected easily by `bin/regenerator --include-runtime script.js`.
        return exports;
      }(
      // If this script is executing as a CommonJS module, use module.exports
      // as the regeneratorRuntime namespace. Otherwise create a new empty
      // object. Either way, the resulting object will be used to initialize
      // the regeneratorRuntime variable at the top of this file.
      true ? module.exports : undefined);
      try {
        regeneratorRuntime = runtime;
      } catch (accidentalStrictMode) {
        // This module should not be running in strict mode, so the above
        // assignment should always work unless something is misconfigured. Just
        // in case runtime.js accidentally runs in strict mode, we can escape
        // strict mode using a global Function call. This could conceivably fail
        // if a Content Security Policy forbids using Function, but in that case
        // the proper solution is to fix the accidental strict mode problem. If
        // you've misconfigured your bundler to force strict mode and applied a
        // CSP to forbid Function, and you're not willing to fix either of those
        // problems, please detail your unique predicament in a GitHub issue.
        Function("r", "regeneratorRuntime = r")(runtime);
      }

      /***/
    }),
    /***/"./src/api.js": (
    /*!********************!*\
      !*** ./src/api.js ***!
      \********************/
    /*! exports provided: setup, setupCache, serializeQuery, default */
    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "setup", function () {
        return setup;
      });
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "setupCache", function () {
        return setupCache;
      });
      /* harmony import */
      var core_js_modules_es7_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es7.object.get-own-property-descriptors */"./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js");
      /* harmony import */
      var core_js_modules_es7_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es7_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es6.symbol */"./node_modules/core-js/modules/es6.symbol.js");
      /* harmony import */
      var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */
      var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es6.array.iterator */"./node_modules/core-js/modules/es6.array.iterator.js");
      /* harmony import */
      var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */
      var core_js_modules_es6_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es6.object.to-string */"./node_modules/core-js/modules/es6.object.to-string.js");
      /* harmony import */
      var core_js_modules_es6_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */
      var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! regenerator-runtime/runtime */"./node_modules/regenerator-runtime/runtime.js");
      /* harmony import */
      var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_4__);
      /* harmony import */
      var axios__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! axios */"axios");
      /* harmony import */
      var axios__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_5__);
      /* harmony import */
      var _request__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./request */"./src/request.js");
      /* harmony import */
      var _cache__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./cache */"./src/cache.js");
      /* harmony reexport (safe) */
      __webpack_require__.d(__webpack_exports__, "serializeQuery", function () {
        return _cache__WEBPACK_IMPORTED_MODULE_7__["serializeQuery"];
      });

      /* harmony import */
      var _config__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./config */"./src/config.js");
      /* harmony import */
      var _utilities__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./utilities */"./src/utilities.js");
      function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target = _objectWithoutPropertiesLoose(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
          var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
          for (i = 0; i < sourceSymbolKeys.length; i++) {
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
          }
        }
        return target;
      }
      function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for (i = 0; i < sourceKeys.length; i++) {
          key = sourceKeys[i];
          if (excluded.indexOf(key) >= 0) continue;
          target[key] = source[key];
        }
        return target;
      }
      function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
          var symbols = Object.getOwnPropertySymbols(object);
          if (enumerableOnly) symbols = symbols.filter(function (sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
          });
          keys.push.apply(keys, symbols);
        }
        return keys;
      }
      function _objectSpread(target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i] != null ? arguments[i] : {};
          if (i % 2) {
            ownKeys(Object(source), true).forEach(function (key) {
              _defineProperty(target, key, source[key]);
            });
          } else if (Object.getOwnPropertyDescriptors) {
            Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
          } else {
            ownKeys(Object(source)).forEach(function (key) {
              Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
          }
        }
        return target;
      }
      function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          });
        } else {
          obj[key] = value;
        }
        return obj;
      }
      function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          Promise.resolve(value).then(_next, _throw);
        }
      }
      function _asyncToGenerator(fn) {
        return function () {
          var self = this,
            args = arguments;
          return new Promise(function (resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
              asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
              asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
          });
        };
      }

      /**
       * Configure cache adapter
       *
       * @param   {object} [config={}] Cache adapter options
       * @returns {object} Object containing cache `adapter` and `store`
       */

      function setupCache() {
        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // Extend default configuration
        config = Object(_config__WEBPACK_IMPORTED_MODULE_8__["makeConfig"])(config); // Axios adapter. Receives the axios request configuration as only parameter

        function adapter(_x) {
          return _adapter.apply(this, arguments);
        } // Return adapter and store instance

        function _adapter() {
          _adapter = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(req) {
            var reqConfig, res, next, networkError, readOnError;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    // Merge the per-request config with the instance config.
                    reqConfig = Object(_config__WEBPACK_IMPORTED_MODULE_8__["mergeRequestConfig"])(config, req); // Execute request against local cache

                    _context.next = 3;
                    return Object(_request__WEBPACK_IMPORTED_MODULE_6__["default"])(reqConfig, req);
                  case 3:
                    res = _context.sent;
                    next = res.next; // Response is not function, something was in cache, return it

                    if (Object(_utilities__WEBPACK_IMPORTED_MODULE_9__["isFunction"])(next)) {
                      _context.next = 7;
                      break;
                    }
                    return _context.abrupt("return", next);
                  case 7:
                    _context.prev = 7;
                    _context.next = 10;
                    return reqConfig.adapter(req);
                  case 10:
                    res = _context.sent;
                    _context.next = 16;
                    break;
                  case 13:
                    _context.prev = 13;
                    _context.t0 = _context["catch"](7);
                    networkError = _context.t0;
                  case 16:
                    if (!networkError) {
                      _context.next = 31;
                      break;
                    }

                    // Check if we should attempt reading stale cache data
                    readOnError = Object(_utilities__WEBPACK_IMPORTED_MODULE_9__["isFunction"])(reqConfig.readOnError) ? reqConfig.readOnError(networkError, req) : reqConfig.readOnError;
                    if (!readOnError) {
                      _context.next = 30;
                      break;
                    }
                    _context.prev = 19;
                    // Force cache tu return stale data
                    reqConfig.acceptStale = true; // Try to read from cache again

                    _context.next = 23;
                    return Object(_request__WEBPACK_IMPORTED_MODULE_6__["default"])(reqConfig, req);
                  case 23:
                    res = _context.sent;
                    // Signal that data is from stale cache
                    res.next.request.stale = true; // No need to check if `next` is a function just return cache data

                    return _context.abrupt("return", res.next);
                  case 28:
                    _context.prev = 28;
                    _context.t1 = _context["catch"](19);
                  case 30:
                    throw networkError;
                  case 31:
                    return _context.abrupt("return", next(res));
                  case 32:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[7, 13], [19, 28]]);
          }));
          return _adapter.apply(this, arguments);
        }
        return {
          adapter: adapter,
          config: config,
          store: config.store
        };
      } // ---------------------
      // Easy API Setup
      // ---------------------

      /**
       * Setup an axios instance with the cache adapter pre-configured
       *
       * @param {object} [options={}] Axios and cache adapter options
       * @returns {object} Instance of Axios
       */

      function setup() {
        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var instanceConfig = _objectSpread(_objectSpread(_objectSpread({}, _config__WEBPACK_IMPORTED_MODULE_8__["defaults"].axios), config), {}, {
          cache: _objectSpread(_objectSpread({}, _config__WEBPACK_IMPORTED_MODULE_8__["defaults"].axios.cache), config.cache)
        });
        var cache = setupCache(instanceConfig.cache);
        var _ = instanceConfig.cache,
          axiosConfig = _objectWithoutProperties(instanceConfig, ["cache"]);
        var api = axios__WEBPACK_IMPORTED_MODULE_5___default.a.create(_objectSpread(_objectSpread({}, axiosConfig), {}, {
          adapter: cache.adapter
        }));
        api.cache = cache.store;
        return api;
      }

      /* harmony default export */
      __webpack_exports__["default"] = {
        setup: setup,
        setupCache: setupCache,
        serializeQuery: _cache__WEBPACK_IMPORTED_MODULE_7__["serializeQuery"]
      };

      /***/
    }),
    /***/"./src/cache.js": (
    /*!**********************!*\
      !*** ./src/cache.js ***!
      \**********************/
    /*! exports provided: read, write, key, invalidate, serializeQuery, default */
    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "read", function () {
        return read;
      });
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "write", function () {
        return write;
      });
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "key", function () {
        return key;
      });
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "invalidate", function () {
        return invalidate;
      });
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "serializeQuery", function () {
        return serializeQuery;
      });
      /* harmony import */
      var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es7.array.includes */"./node_modules/core-js/modules/es7.array.includes.js");
      /* harmony import */
      var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es6.string.includes */"./node_modules/core-js/modules/es6.string.includes.js");
      /* harmony import */
      var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */
      var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! regenerator-runtime/runtime */"./node_modules/regenerator-runtime/runtime.js");
      /* harmony import */
      var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */
      var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es6.array.iterator */"./node_modules/core-js/modules/es6.array.iterator.js");
      /* harmony import */
      var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */
      var core_js_modules_es6_object_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! core-js/modules/es6.object.to-string */"./node_modules/core-js/modules/es6.object.to-string.js");
      /* harmony import */
      var core_js_modules_es6_object_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_object_to_string__WEBPACK_IMPORTED_MODULE_4__);
      /* harmony import */
      var _utilities__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./utilities */"./src/utilities.js");
      /* harmony import */
      var md5__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! md5 */"./node_modules/md5/md5.js");
      /* harmony import */
      var md5__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(md5__WEBPACK_IMPORTED_MODULE_6__);
      /* harmony import */
      var _serialize__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./serialize */"./src/serialize.js");
      function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          Promise.resolve(value).then(_next, _throw);
        }
      }
      function _asyncToGenerator(fn) {
        return function () {
          var self = this,
            args = arguments;
          return new Promise(function (resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
              asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
              asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
          });
        };
      }
      function write(_x, _x2, _x3) {
        return _write.apply(this, arguments);
      }
      function _write() {
        _write = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(config, req, res) {
          var entry;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  entry = {
                    expires: config.expires,
                    data: Object(_serialize__WEBPACK_IMPORTED_MODULE_7__["default"])(config, req, res)
                  };
                  _context.next = 4;
                  return config.store.setItem(config.uuid, entry);
                case 4:
                  _context.next = 19;
                  break;
                case 6:
                  _context.prev = 6;
                  _context.t0 = _context["catch"](0);
                  config.debug('Could not store response', _context.t0);
                  if (!config.clearOnError) {
                    _context.next = 18;
                    break;
                  }
                  _context.prev = 10;
                  _context.next = 13;
                  return config.store.clear();
                case 13:
                  _context.next = 18;
                  break;
                case 15:
                  _context.prev = 15;
                  _context.t1 = _context["catch"](10);
                  config.debug('Could not clear store', _context.t1);
                case 18:
                  return _context.abrupt("return", false);
                case 19:
                  return _context.abrupt("return", true);
                case 20:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 6], [10, 15]]);
        }));
        return _write.apply(this, arguments);
      }
      function read(_x4, _x5) {
        return _read.apply(this, arguments);
      }
      function _read() {
        _read = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(config, req) {
          var uuid, ignoreCache, entry, error, expires, data, offline, _error;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  uuid = config.uuid, ignoreCache = config.ignoreCache;
                  _context2.next = 3;
                  return config.store.getItem(uuid);
                case 3:
                  entry = _context2.sent;
                  if (!(ignoreCache || !entry || !entry.data)) {
                    _context2.next = 10;
                    break;
                  }
                  config.debug('cache-miss', req.url);
                  error = new Error();
                  error.reason = 'cache-miss';
                  error.message = 'Entry not found from cache';
                  throw error;
                case 10:
                  expires = entry.expires, data = entry.data; // Do not check for stale cache if offline on client-side

                  offline = typeof navigator !== 'undefined' && 'onLine' in navigator && !navigator.onLine;
                  if (!(!offline && !config.acceptStale && expires !== 0 && expires < Date.now())) {
                    _context2.next = 18;
                    break;
                  }
                  config.debug('cache-stale', req.url);
                  _error = new Error();
                  _error.reason = 'cache-stale';
                  _error.message = 'Entry is stale';
                  throw _error;
                case 18:
                  config.debug(config.acceptStale ? 'cache-hit-stale' : 'cache-hit', req.url);
                  return _context2.abrupt("return", data);
                case 20:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));
        return _read.apply(this, arguments);
      }
      function key(config) {
        if (Object(_utilities__WEBPACK_IMPORTED_MODULE_5__["isFunction"])(config.key)) return config.key;
        var cacheKey;
        if (Object(_utilities__WEBPACK_IMPORTED_MODULE_5__["isString"])(config.key)) {
          cacheKey = function cacheKey(req) {
            var url = "".concat(req.baseURL ? req.baseURL : '').concat(req.url);
            var key = "".concat(config.key, "/").concat(url).concat(serializeQuery(req));
            return req.data ? key + md5__WEBPACK_IMPORTED_MODULE_6___default()(req.data) : key;
          };
        } else {
          cacheKey = function cacheKey(req) {
            var url = "".concat(req.baseURL ? req.baseURL : '').concat(req.url);
            var key = url + serializeQuery(req);
            return req.data ? key + md5__WEBPACK_IMPORTED_MODULE_6___default()(req.data) : key;
          };
        }
        return cacheKey;
      }
      function defaultInvalidate(_x6, _x7) {
        return _defaultInvalidate.apply(this, arguments);
      }
      function _defaultInvalidate() {
        _defaultInvalidate = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(config, req) {
          var method;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  method = req.method.toLowerCase();
                  if (!config.exclude.methods.includes(method)) {
                    _context3.next = 4;
                    break;
                  }
                  _context3.next = 4;
                  return config.store.removeItem(config.uuid);
                case 4:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));
        return _defaultInvalidate.apply(this, arguments);
      }
      function invalidate() {
        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (Object(_utilities__WEBPACK_IMPORTED_MODULE_5__["isFunction"])(config.invalidate)) return config.invalidate;
        return defaultInvalidate;
      }
      function serializeQuery(req) {
        if (!req.params) return ''; // Probably server-side, just stringify the object

        if (typeof URLSearchParams === 'undefined') return JSON.stringify(req.params);
        var params = req.params;
        var isInstanceOfURLSearchParams = req.params instanceof URLSearchParams; // Convert to an instance of URLSearchParams so it get serialized the same way

        if (!isInstanceOfURLSearchParams) {
          params = new URLSearchParams();
          Object.keys(req.params).forEach(function (key) {
            return params.append(key, req.params[key]);
          });
        }
        return "?".concat(params.toString());
      }

      /* harmony default export */
      __webpack_exports__["default"] = {
        read: read,
        write: write,
        key: key,
        invalidate: invalidate,
        serializeQuery: serializeQuery
      };

      /***/
    }),
    /***/"./src/config.js": (
    /*!***********************!*\
      !*** ./src/config.js ***!
      \***********************/
    /*! exports provided: defaults, makeConfig, mergeRequestConfig, default */
    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "defaults", function () {
        return defaults;
      });
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "makeConfig", function () {
        return makeConfig;
      });
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "mergeRequestConfig", function () {
        return mergeRequestConfig;
      });
      /* harmony import */
      var core_js_modules_es7_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es7.object.get-own-property-descriptors */"./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js");
      /* harmony import */
      var core_js_modules_es7_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es7_object_get_own_property_descriptors__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es6.symbol */"./node_modules/core-js/modules/es6.symbol.js");
      /* harmony import */
      var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */
      var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es6.array.iterator */"./node_modules/core-js/modules/es6.array.iterator.js");
      /* harmony import */
      var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */
      var core_js_modules_es6_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es6.object.to-string */"./node_modules/core-js/modules/es6.object.to-string.js");
      /* harmony import */
      var core_js_modules_es6_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */
      var axios__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! axios */"axios");
      /* harmony import */
      var axios__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_4__);
      /* harmony import */
      var _memory__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./memory */"./src/memory.js");
      /* harmony import */
      var _cache__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./cache */"./src/cache.js");
      function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
          var symbols = Object.getOwnPropertySymbols(object);
          if (enumerableOnly) symbols = symbols.filter(function (sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
          });
          keys.push.apply(keys, symbols);
        }
        return keys;
      }
      function _objectSpread(target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i] != null ? arguments[i] : {};
          if (i % 2) {
            ownKeys(Object(source), true).forEach(function (key) {
              _defineProperty(target, key, source[key]);
            });
          } else if (Object.getOwnPropertyDescriptors) {
            Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
          } else {
            ownKeys(Object(source)).forEach(function (key) {
              Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
          }
        }
        return target;
      }
      function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          });
        } else {
          obj[key] = value;
        }
        return obj;
      }
      var noop = function noop() {};
      var debug = function debug() {
        var _console;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return (_console = console).log.apply(_console, ['[axios-cache-adapter]'].concat(args));
      };
      var defaults = {
        // Default settings when solely creating the cache adapter with setupCache.
        cache: {
          maxAge: 0,
          limit: false,
          store: null,
          key: null,
          invalidate: null,
          exclude: {
            paths: [],
            query: true,
            filter: null,
            methods: ['post', 'patch', 'put', 'delete']
          },
          adapter: axios__WEBPACK_IMPORTED_MODULE_4___default.a.defaults.adapter,
          clearOnStale: true,
          clearOnError: true,
          readOnError: false,
          readHeaders: false,
          debug: false,
          ignoreCache: false
        },
        // Additional defaults when creating the axios instance with the cache adapter.
        axios: {
          cache: {
            maxAge: 15 * 60 * 1000
          }
        }
      }; // List of disallowed in the per-request config.

      var disallowedPerRequestKeys = ['limit', 'store', 'adapter', 'uuid', 'acceptStale'];
      /**
       * Make a global config object.
       *
       * @param {Object} [override={}] Optional config override.
       * @return {Object}
       */

      var makeConfig = function makeConfig() {
        var override = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var config = _objectSpread(_objectSpread(_objectSpread({}, defaults.cache), override), {}, {
          exclude: _objectSpread(_objectSpread({}, defaults.cache.exclude), override.exclude)
        }); // Create a cache key method

        config.key = Object(_cache__WEBPACK_IMPORTED_MODULE_6__["key"])(config);
        config.invalidate = Object(_cache__WEBPACK_IMPORTED_MODULE_6__["invalidate"])(config); // If debug mode is on, create a simple logger method

        if (config.debug !== false) {
          config.debug = typeof config.debug === 'function' ? config.debug : debug;
        } else {
          config.debug = noop;
        } // Create an in memory store if none was given

        if (!config.store) config.store = new _memory__WEBPACK_IMPORTED_MODULE_5__["default"]();
        config.debug('Global cache config', config);
        return config;
      };
      /**
       * Merge the per-request config in another config.
       *
       * This method exists because not all keys should be allowed as it
       * may lead to unexpected behaviours. For instance, setting another
       * store or adapter per request is wrong, instead another instance
       * axios, or the adapter, should be used.
       *
       * @param {Object} config Config object.
       * @param {Object} req    The current axios request
       * @return {Object}
       */

      var mergeRequestConfig = function mergeRequestConfig(config, req) {
        var requestConfig = req.cache || {};
        if (requestConfig) {
          disallowedPerRequestKeys.forEach(function (key) {
            return requestConfig[key] ? delete requestConfig[key] : undefined;
          });
        }
        var mergedConfig = _objectSpread(_objectSpread(_objectSpread({}, config), requestConfig), {}, {
          exclude: _objectSpread(_objectSpread({}, config.exclude), requestConfig.exclude)
        });
        if (mergedConfig.debug === true) {
          mergedConfig.debug = debug;
        } // Create a cache key method

        if (requestConfig.key) {
          mergedConfig.key = Object(_cache__WEBPACK_IMPORTED_MODULE_6__["key"])(requestConfig);
        } // Generate request UUID

        mergedConfig.uuid = mergedConfig.key(req);
        config.debug("Request config for ".concat(req.url), mergedConfig);
        return mergedConfig;
      };

      /* harmony default export */
      __webpack_exports__["default"] = {
        defaults: defaults,
        makeConfig: makeConfig,
        mergeRequestConfig: mergeRequestConfig
      };

      /***/
    }),
    /***/"./src/exclude.js": (
    /*!************************!*\
      !*** ./src/exclude.js ***!
      \************************/
    /*! exports provided: default */
    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony import */
      var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es6.array.iterator */"./node_modules/core-js/modules/es6.array.iterator.js");
      /* harmony import */
      var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var core_js_modules_es6_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es6.object.to-string */"./node_modules/core-js/modules/es6.object.to-string.js");
      /* harmony import */
      var core_js_modules_es6_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */
      var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es7.array.includes */"./node_modules/core-js/modules/es7.array.includes.js");
      /* harmony import */
      var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */
      var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es6.string.includes */"./node_modules/core-js/modules/es6.string.includes.js");
      /* harmony import */
      var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */
      var _utilities__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./utilities */"./src/utilities.js");
      function exclude() {
        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var req = arguments.length > 1 ? arguments[1] : undefined;
        var _config$exclude = config.exclude,
          exclude = _config$exclude === void 0 ? {} : _config$exclude,
          debug = config.debug;
        var method = req.method.toLowerCase();
        if (method === 'head' || exclude.methods.includes(method)) {
          debug("Excluding request by HTTP method ".concat(req.url));
          return true;
        }
        if (typeof exclude.filter === 'function' && exclude.filter(req)) {
          debug("Excluding request by filter ".concat(req.url));
          return true;
        } // do not cache request with query

        var hasQueryParams = /\?.*$/.test(req.url) || Object(_utilities__WEBPACK_IMPORTED_MODULE_4__["isObject"])(req.params) && Object.keys(req.params).length !== 0 || typeof URLSearchParams !== 'undefined' && req.params instanceof URLSearchParams;
        if (exclude.query && hasQueryParams) {
          debug("Excluding request by query ".concat(req.url));
          return true;
        }
        var paths = exclude.paths || [];
        var found = paths.some(function (regexp) {
          return req.url.match(regexp);
        });
        if (found) {
          debug("Excluding request by url match ".concat(req.url));
          return true;
        }
        return false;
      }

      /* harmony default export */
      __webpack_exports__["default"] = exclude;

      /***/
    }),
    /***/"./src/index.js": (
    /*!**********************!*\
      !*** ./src/index.js ***!
      \**********************/
    /*! exports provided: setup, setupCache, serializeQuery, default */
    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony import */
      var _api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./api */"./src/api.js");
      /* harmony reexport (safe) */
      __webpack_require__.d(__webpack_exports__, "setup", function () {
        return _api__WEBPACK_IMPORTED_MODULE_0__["setup"];
      });

      /* harmony reexport (safe) */
      __webpack_require__.d(__webpack_exports__, "setupCache", function () {
        return _api__WEBPACK_IMPORTED_MODULE_0__["setupCache"];
      });

      /* harmony reexport (safe) */
      __webpack_require__.d(__webpack_exports__, "serializeQuery", function () {
        return _api__WEBPACK_IMPORTED_MODULE_0__["serializeQuery"];
      });

      /* harmony reexport (safe) */
      __webpack_require__.d(__webpack_exports__, "default", function () {
        return _api__WEBPACK_IMPORTED_MODULE_0__["default"];
      });

      /***/
    }),
    /***/"./src/limit.js": (
    /*!**********************!*\
      !*** ./src/limit.js ***!
      \**********************/
    /*! exports provided: default */
    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony import */
      var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! regenerator-runtime/runtime */"./node_modules/regenerator-runtime/runtime.js");
      /* harmony import */
      var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var core_js_modules_es6_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es6.object.to-string */"./node_modules/core-js/modules/es6.object.to-string.js");
      /* harmony import */
      var core_js_modules_es6_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
      function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          Promise.resolve(value).then(_next, _throw);
        }
      }
      function _asyncToGenerator(fn) {
        return function () {
          var self = this,
            args = arguments;
          return new Promise(function (resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
              asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
              asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
          });
        };
      }
      function limit(_x) {
        return _limit.apply(this, arguments);
      }
      function _limit() {
        _limit = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(config) {
          var length, firstItem;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return config.store.length();
                case 2:
                  length = _context.sent;
                  if (!(length < config.limit)) {
                    _context.next = 5;
                    break;
                  }
                  return _context.abrupt("return");
                case 5:
                  config.debug("Current store size: ".concat(length));
                  _context.next = 8;
                  return config.store.iterate(function (value, key) {
                    if (!firstItem) firstItem = {
                      value: value,
                      key: key
                    };
                    if (value.expires < firstItem.value.expires) firstItem = {
                      value: value,
                      key: key
                    };
                  });
                case 8:
                  if (!firstItem) {
                    _context.next = 12;
                    break;
                  }
                  config.debug("Removing item: ".concat(firstItem.key));
                  _context.next = 12;
                  return config.store.removeItem(firstItem.key);
                case 12:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
        return _limit.apply(this, arguments);
      }

      /* harmony default export */
      __webpack_exports__["default"] = limit;

      /***/
    }),
    /***/"./src/memory.js": (
    /*!***********************!*\
      !*** ./src/memory.js ***!
      \***********************/
    /*! exports provided: default */
    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony import */
      var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es6.array.iterator */"./node_modules/core-js/modules/es6.array.iterator.js");
      /* harmony import */
      var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var core_js_modules_es6_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es6.object.to-string */"./node_modules/core-js/modules/es6.object.to-string.js");
      /* harmony import */
      var core_js_modules_es6_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */
      var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! regenerator-runtime/runtime */"./node_modules/regenerator-runtime/runtime.js");
      /* harmony import */
      var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */
      var _utilities__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./utilities */"./src/utilities.js");
      function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          Promise.resolve(value).then(_next, _throw);
        }
      }
      function _asyncToGenerator(fn) {
        return function () {
          var self = this,
            args = arguments;
          return new Promise(function (resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
              asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
              asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
          });
        };
      }
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
      }
      var MemoryStore = /*#__PURE__*/function () {
        function MemoryStore() {
          _classCallCheck(this, MemoryStore);
          this.store = {};
        }
        _createClass(MemoryStore, [{
          key: "getItem",
          value: function () {
            var _getItem = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(key) {
              var item;
              return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      item = this.store[key] || null;
                      return _context.abrupt("return", JSON.parse(item));
                    case 2:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, this);
            }));
            function getItem(_x) {
              return _getItem.apply(this, arguments);
            }
            return getItem;
          }()
        }, {
          key: "setItem",
          value: function () {
            var _setItem = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(key, value) {
              return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      this.store[key] = JSON.stringify(value);
                      return _context2.abrupt("return", value);
                    case 2:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2, this);
            }));
            function setItem(_x2, _x3) {
              return _setItem.apply(this, arguments);
            }
            return setItem;
          }()
        }, {
          key: "removeItem",
          value: function () {
            var _removeItem = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(key) {
              return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      delete this.store[key];
                    case 1:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3, this);
            }));
            function removeItem(_x4) {
              return _removeItem.apply(this, arguments);
            }
            return removeItem;
          }()
        }, {
          key: "clear",
          value: function () {
            var _clear = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
              return regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      this.store = {};
                    case 1:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _callee4, this);
            }));
            function clear() {
              return _clear.apply(this, arguments);
            }
            return clear;
          }()
        }, {
          key: "length",
          value: function () {
            var _length = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
              return regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      return _context5.abrupt("return", Object.keys(this.store).length);
                    case 1:
                    case "end":
                      return _context5.stop();
                  }
                }
              }, _callee5, this);
            }));
            function length() {
              return _length.apply(this, arguments);
            }
            return length;
          }()
        }, {
          key: "iterate",
          value: function iterate(fn) {
            return Promise.all(Object(_utilities__WEBPACK_IMPORTED_MODULE_3__["mapObject"])(this.store, fn));
          }
        }]);
        return MemoryStore;
      }();

      /* harmony default export */
      __webpack_exports__["default"] = MemoryStore;

      /***/
    }),
    /***/"./src/request.js": (
    /*!************************!*\
      !*** ./src/request.js ***!
      \************************/
    /*! exports provided: default */
    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony import */
      var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! regenerator-runtime/runtime */"./node_modules/regenerator-runtime/runtime.js");
      /* harmony import */
      var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var core_js_modules_es6_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es6.object.to-string */"./node_modules/core-js/modules/es6.object.to-string.js");
      /* harmony import */
      var core_js_modules_es6_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */
      var _response__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./response */"./src/response.js");
      /* harmony import */
      var _exclude__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./exclude */"./src/exclude.js");
      /* harmony import */
      var _cache__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./cache */"./src/cache.js");
      function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          Promise.resolve(value).then(_next, _throw);
        }
      }
      function _asyncToGenerator(fn) {
        return function () {
          var self = this,
            args = arguments;
          return new Promise(function (resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
              asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
              asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
          });
        };
      }
      function request(_x, _x2) {
        return _request.apply(this, arguments);
      }
      function _request() {
        _request = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(config, req) {
          var next, res, excludeFromCache;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  excludeFromCache = function _excludeFromCache() {
                    config.excludeFromCache = true;
                    return {
                      config: config,
                      next: next
                    };
                  };
                  config.debug('uuid', config.uuid);
                  next = function next() {
                    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                      args[_key] = arguments[_key];
                    }
                    return _response__WEBPACK_IMPORTED_MODULE_2__["default"].apply(void 0, [config, req].concat(args));
                  }; // run invalidate function to check if any cache items need to be invalidated.

                  _context.next = 5;
                  return config.invalidate(config, req);
                case 5:
                  if (!Object(_exclude__WEBPACK_IMPORTED_MODULE_3__["default"])(config, req)) {
                    _context.next = 7;
                    break;
                  }
                  return _context.abrupt("return", excludeFromCache());
                case 7:
                  _context.prev = 7;
                  _context.next = 10;
                  return Object(_cache__WEBPACK_IMPORTED_MODULE_4__["read"])(config, req);
                case 10:
                  res = _context.sent;
                  res.config = req;
                  res.request = {
                    fromCache: true
                  };
                  return _context.abrupt("return", {
                    config: config,
                    next: res
                  });
                case 16:
                  _context.prev = 16;
                  _context.t0 = _context["catch"](7);
                  if (!(config.clearOnStale && _context.t0.reason === 'cache-stale')) {
                    _context.next = 21;
                    break;
                  }
                  _context.next = 21;
                  return config.store.removeItem(config.uuid);
                case 21:
                  return _context.abrupt("return", {
                    config: config,
                    next: next
                  });
                case 22:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[7, 16]]);
        }));
        return _request.apply(this, arguments);
      }

      /* harmony default export */
      __webpack_exports__["default"] = request;

      /***/
    }),
    /***/"./src/response.js": (
    /*!*************************!*\
      !*** ./src/response.js ***!
      \*************************/
    /*! exports provided: default */
    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony import */
      var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! regenerator-runtime/runtime */"./node_modules/regenerator-runtime/runtime.js");
      /* harmony import */
      var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var core_js_modules_es6_object_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es6.object.to-string */"./node_modules/core-js/modules/es6.object.to-string.js");
      /* harmony import */
      var core_js_modules_es6_object_to_string__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_object_to_string__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */
      var _limit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./limit */"./src/limit.js");
      /* harmony import */
      var _cache__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./cache */"./src/cache.js");
      /* harmony import */
      var cache_control_esm__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! cache-control-esm */"./node_modules/cache-control-esm/index.js");
      function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          Promise.resolve(value).then(_next, _throw);
        }
      }
      function _asyncToGenerator(fn) {
        return function () {
          var self = this,
            args = arguments;
          return new Promise(function (resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
              asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
              asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
          });
        };
      }
      function response(_x, _x2, _x3) {
        return _response.apply(this, arguments);
      }
      function _response() {
        _response = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(config, req, res) {
          var _res$request, request, _res$headers, headers, cacheControl;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _res$request = res.request, request = _res$request === void 0 ? {} : _res$request, _res$headers = res.headers, headers = _res$headers === void 0 ? {} : _res$headers; // exclude binary response from cache

                  if (!(['arraybuffer', 'blob'].indexOf(request.responseType) > -1)) {
                    _context.next = 3;
                    break;
                  }
                  return _context.abrupt("return", res);
                case 3:
                  cacheControl = {}; // Should we try to determine request cache expiration from headers or not

                  if (config.readHeaders) {
                    if (headers['cache-control']) {
                      // Try parsing `cache-control` header from response
                      cacheControl = Object(cache_control_esm__WEBPACK_IMPORTED_MODULE_4__["parse"])(headers['cache-control']); // Force cache exlcusion for `cache-control: no-cache` and `cache-control: no-store`

                      if (cacheControl.noCache || cacheControl.noStore) {
                        config.excludeFromCache = true;
                      }
                    } else if (headers.expires) {
                      // Else try reading `expires` header
                      config.expires = new Date(headers.expires).getTime();
                    } else {
                      config.expires = new Date().getTime();
                    }
                  }
                  if (config.excludeFromCache) {
                    _context.next = 15;
                    break;
                  }
                  if (cacheControl.maxAge || cacheControl.maxAge === 0) {
                    // Use `cache-control` header `max-age` value and convert to milliseconds
                    config.expires = Date.now() + cacheControl.maxAge * 1000;
                  } else if (!config.readHeaders) {
                    // Use fixed `maxAge` defined in the global or per-request config
                    config.expires = config.maxAge === 0 ? Date.now() : Date.now() + config.maxAge;
                  } // Check if a cache limit has been configured

                  if (!config.limit) {
                    _context.next = 11;
                    break;
                  }
                  config.debug("Detected limit: ".concat(config.limit));
                  _context.next = 11;
                  return Object(_limit__WEBPACK_IMPORTED_MODULE_2__["default"])(config);
                case 11:
                  _context.next = 13;
                  return Object(_cache__WEBPACK_IMPORTED_MODULE_3__["write"])(config, req, res);
                case 13:
                  _context.next = 16;
                  break;
                case 15:
                  // Mark request as excluded from cache
                  res.request.excludedFromCache = true;
                case 16:
                  return _context.abrupt("return", res);
                case 17:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
        return _response.apply(this, arguments);
      }

      /* harmony default export */
      __webpack_exports__["default"] = response;

      /***/
    }),
    /***/"./src/serialize.js": (
    /*!**************************!*\
      !*** ./src/serialize.js ***!
      \**************************/
    /*! exports provided: default */
    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony import */
      var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es6.symbol */"./node_modules/core-js/modules/es6.symbol.js");
      /* harmony import */
      var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es6.array.iterator */"./node_modules/core-js/modules/es6.array.iterator.js");
      /* harmony import */
      var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */
      var core_js_modules_es6_object_to_string__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es6.object.to-string */"./node_modules/core-js/modules/es6.object.to-string.js");
      /* harmony import */
      var core_js_modules_es6_object_to_string__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_object_to_string__WEBPACK_IMPORTED_MODULE_2__);
      function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target = _objectWithoutPropertiesLoose(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
          var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
          for (i = 0; i < sourceSymbolKeys.length; i++) {
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
          }
        }
        return target;
      }
      function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for (i = 0; i < sourceKeys.length; i++) {
          key = sourceKeys[i];
          if (excluded.indexOf(key) >= 0) continue;
          target[key] = source[key];
        }
        return target;
      }
      function serialize(config, req, res) {
        if (res.data) {
          // FIXME: May be useless as localForage and axios already parse automatically
          try {
            res.data = JSON.parse(res.data);
          } catch (err) {
            config.debug('Could not parse data as JSON', err);
          }
        }
        var request = res.request,
          _ = res.config,
          serialized = _objectWithoutProperties(res, ["request", "config"]);
        return serialized;
      }

      /* harmony default export */
      __webpack_exports__["default"] = serialize;

      /***/
    }),
    /***/"./src/utilities.js": (
    /*!**************************!*\
      !*** ./src/utilities.js ***!
      \**************************/
    /*! exports provided: isObject, getTag, isFunction, isString, mapObject */
    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "isObject", function () {
        return isObject;
      });
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "getTag", function () {
        return getTag;
      });
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "isFunction", function () {
        return isFunction;
      });
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "isString", function () {
        return isString;
      });
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "mapObject", function () {
        return mapObject;
      });
      /* harmony import */
      var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! core-js/modules/es7.symbol.async-iterator */"./node_modules/core-js/modules/es7.symbol.async-iterator.js");
      /* harmony import */
      var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! core-js/modules/es6.symbol */"./node_modules/core-js/modules/es6.symbol.js");
      /* harmony import */
      var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */
      var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! core-js/modules/es6.array.iterator */"./node_modules/core-js/modules/es6.array.iterator.js");
      /* harmony import */
      var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */
      var core_js_modules_es6_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/es6.object.to-string */"./node_modules/core-js/modules/es6.object.to-string.js");
      /* harmony import */
      var core_js_modules_es6_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es6_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
      function _typeof(obj) {
        "@babel/helpers - typeof";

        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
          _typeof = function _typeof(obj) {
            return typeof obj;
          };
        } else {
          _typeof = function _typeof(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
          };
        }
        return _typeof(obj);
      }

      // https://github.com/lodash/lodash/blob/master/isObject.js
      function isObject(value) {
        var type = _typeof(value);
        return value != null && (type === 'object' || type === 'function');
      } // https://github.com/lodash/lodash/blob/master/.internal/getTag.js

      function getTag(value) {
        if (value === null) {
          return value === undefined ? '[object Undefined]' : '[object Null]';
        }
        return Object.prototype.toString.call(value);
      } // https://github.com/lodash/lodash/blob/master/isFunction.js

      function isFunction(value) {
        if (!isObject(value)) {
          return false;
        }
        var tag = getTag(value);
        return tag === '[object Function]' || tag === '[object AsyncFunction]' || tag === '[object GeneratorFunction]' || tag === '[object Proxy]';
      } // https://github.com/lodash/lodash/blob/master/isString.js

      function isString(value) {
        var type = _typeof(value);
        return type === 'string' || type === 'object' && value != null && !Array.isArray(value) && getTag(value) === '[object String]';
      }
      function mapObject(value, fn) {
        if (!isObject(value)) {
          return [];
        }
        return Object.keys(value).map(function (key) {
          return fn(value[key], key);
        });
      }

      /***/
    }),
    /***/"axios": (
    /*!*************************************************************************************!*\
      !*** external {"umd":"axios","amd":"axios","commonjs":"axios","commonjs2":"axios"} ***!
      \*************************************************************************************/
    /*! no static exports found */
    /***/
    function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_axios__;

      /***/
    })

    /******/
  });
});
